(function(){
  document.querySelectorAll('[data-pp-config]').forEach(function(cfgEl){
    var cfg=JSON.parse(cfgEl.textContent);
    var S=document.getElementById('cds-pp-'+cfg.sectionId);
    if(!S)return;
    _initCdsPP(S,cfg);
  });
  function _initCdsPP(S,cfg){
  var PD = JSON.parse(S.querySelector('[data-product-json]').textContent);
  var _bm=S.querySelector('[data-variant-buyable]');if(_bm){try{var bmap=JSON.parse('{'+_bm.textContent+'}');PD.variants.forEach(function(v){if(bmap[v.id]!==undefined)v.available=bmap[v.id]})}catch(e){console.warn('[CDS] buyable map parse error:',e)}}

  var CV = findById(cfg.currentVariantId);
  var opts = CV ? CV.options.slice() : [];
  var MF = cfg.moneyFormat;
  var atcT = cfg.atcText;
  var soldT = cfg.soldOutText;
  var moreT = cfg.seeMoreText;
  var lessT = cfg.seeLessText;
  var showP = cfg.showPriceInAtc;
  var instC = cfg.installmentCount;
  var showI = cfg.showInstallment;
  var imgURLs = cfg.imgUrls;
  var variantMediaMap = cfg.variantMedia;

  function escapeHtml(str){var div=document.createElement('div');div.textContent=str;return div.innerHTML}
  function findById(id){for(var i=0;i<PD.variants.length;i++){if(PD.variants[i].id===id)return PD.variants[i]}return null}
  function findV(o){for(var i=0;i<PD.variants.length;i++){var v=PD.variants[i],m=true;for(var j=0;j<o.length;j++){if(v.options[j]!==o[j]){m=false;break}}if(m)return v}return null}
  function fmt(c){if(c==null)return'';var a=(c/100).toFixed(2),ac=a.replace('.',','),an=Math.round(c/100).toString();return MF.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g,ac.replace(/\B(?=(\d{3})+(?!\d))/g,'.')).replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g,an.replace(/\B(?=(\d{3})+(?!\d))/g,'.')).replace(/\{\{\s*amount_no_decimals\s*\}\}/g,an).replace(/\{\{\s*amount\s*\}\}/g,a)}

  /* Gallery */
  function initGallery(){
    var thumbs=S.querySelectorAll('.cds-pp__thumb'),slides=S.querySelectorAll('.cds-pp__slide');
    if(!thumbs.length||!slides.length)return;
    var mediaMain=S.querySelector('.cds-pp__media-main');
    function syncHeight(){if(!mediaMain)return;var active=mediaMain.querySelector('.cds-pp__slide.is-active');if(active)mediaMain.style.height=active.scrollHeight+'px'}
    thumbs.forEach(function(t){t.addEventListener('click',function(){go(parseInt(this.dataset.index))})});
    S._go=go;
    function go(i){var pI=-1;slides.forEach(function(s,j){if(s.classList.contains('is-active'))pI=j;s.classList.remove('is-active')});thumbs.forEach(function(t){t.classList.remove('is-active')});if(slides[i])slides[i].classList.add('is-active');if(thumbs[i]){thumbs[i].classList.add('is-active');var tc=thumbs[0].parentElement;if(tc&&pI!==-1&&pI!==i){var isV=tc.classList.contains('cds-pp__thumbs--vertical_left')||tc.classList.contains('cds-pp__thumbs--out_left');if(Math.abs(i-pI)>1){var pos=i<pI?0:(isV?tc.scrollHeight:tc.scrollWidth);tc.scrollTo(isV?{top:pos,behavior:'smooth'}:{left:pos,behavior:'smooth'})}else{var step=(isV?thumbs[0].offsetHeight:thumbs[0].offsetWidth)+8;var dir=i>pI?1:-1;tc.scrollBy(isV?{top:dir*step,behavior:'smooth'}:{left:dir*step,behavior:'smooth'})}}}syncHeight()}
    /* Set initial height after first image loads to prevent zero-height container */
    var firstImg=mediaMain?mediaMain.querySelector('.cds-pp__slide.is-active img'):null;
    if(firstImg){if(firstImg.complete){syncHeight()}else{firstImg.addEventListener('load',syncHeight)}}
    S._syncGalleryHeight=syncHeight;
    /* Desktop nav arrows */
    var navPrev=S.querySelector('[data-nav-prev]'),navNext=S.querySelector('[data-nav-next]');
    if(navPrev&&navNext){
      var navIdx=0;
      navPrev.addEventListener('click',function(){navIdx=(navIdx-1+slides.length)%slides.length;go(navIdx)});
      navNext.addEventListener('click',function(){navIdx=(navIdx+1)%slides.length;go(navIdx)});
      thumbs.forEach(function(t){t.addEventListener('click',function(){navIdx=parseInt(this.dataset.index)})});
    }
    /* Thumb strip chevrons — scroll by one thumb */
    var thumbContainer=thumbs[0]?thumbs[0].parentElement:null;
    var tNavPrev=S.querySelector('[data-thumb-nav="prev"]'),tNavNext=S.querySelector('[data-thumb-nav="next"]');
    if(thumbContainer&&tNavPrev&&tNavNext){
      var isVert=thumbContainer.classList.contains('cds-pp__thumbs--vertical_left')||thumbContainer.classList.contains('cds-pp__thumbs--out_left');
      var tStep=thumbs[0]?(isVert?thumbs[0].offsetHeight:thumbs[0].offsetWidth)+8:64;
      tNavPrev.addEventListener('click',function(){thumbContainer.scrollBy(isVert?{top:-tStep,behavior:'smooth'}:{left:-tStep,behavior:'smooth'})});
      tNavNext.addEventListener('click',function(){thumbContainer.scrollBy(isVert?{top:tStep,behavior:'smooth'}:{left:tStep,behavior:'smooth'})});
    }
  }

  /* Carousel + mobile thumbs */
  function initCarousel(){
    var c=S.querySelector('.cds-pp__carousel'),dots=S.querySelectorAll('.cds-pp__dot'),mthumbs=S.querySelectorAll('.cds-pp__mobile-thumb');
    if(!c)return;
    function goMobile(i){if(!c)return;c.scrollTo({left:i*c.offsetWidth,behavior:'smooth'})}
    S._goMobile=goMobile;
    var slideCount=c.children.length;
    var lastMI=0;var t;c.addEventListener('scroll',function(){clearTimeout(t);t=setTimeout(function(){var i=Math.round(c.scrollLeft/c.offsetWidth);dots.forEach(function(d,j){d.classList.toggle('is-active',j===i)});mthumbs.forEach(function(m,j){m.classList.toggle('is-active',j===i)});if(mthumbs[0]&&lastMI!==i){var mc=S.querySelector('[data-mobile-thumbs]');if(mc){if(Math.abs(i-lastMI)>1){mc.scrollTo({left:i<lastMI?0:mc.scrollWidth,behavior:'smooth'})}else{var dir=i>lastMI?1:-1;var step=mthumbs[0].offsetWidth+6;mc.scrollBy({left:dir*step,behavior:'smooth'})}}}lastMI=i},50)},{passive:true});
    dots.forEach(function(d){d.addEventListener('click',function(){goMobile(parseInt(this.dataset.slide))})});
    mthumbs.forEach(function(m){m.addEventListener('click',function(){goMobile(parseInt(this.dataset.mobileThumb))})});
    /* Mobile carousel nav arrows */
    var cPrev=S.querySelector('[data-carousel-prev]'),cNext=S.querySelector('[data-carousel-next]');
    if(cPrev&&cNext){
      cPrev.addEventListener('click',function(){var i=Math.round(c.scrollLeft/c.offsetWidth);goMobile(i>0?i-1:slideCount-1)});
      cNext.addEventListener('click',function(){var i=Math.round(c.scrollLeft/c.offsetWidth);goMobile(i<slideCount-1?i+1:0)});
    }
    /* Mobile thumb strip chevrons */
    var mtContainer=S.querySelector('[data-mobile-thumbs]');
    var mtNavPrev=S.querySelector('[data-mthumb-nav="prev"]'),mtNavNext=S.querySelector('[data-mthumb-nav="next"]');
    if(mtContainer&&mtNavPrev&&mtNavNext){
      var mtStep=mthumbs[0]?mthumbs[0].offsetWidth+6:50;
      mtNavPrev.addEventListener('click',function(){mtContainer.scrollBy({left:-mtStep,behavior:'smooth'})});
      mtNavNext.addEventListener('click',function(){mtContainer.scrollBy({left:mtStep,behavior:'smooth'})});
    }
    /* Skeleton: mark slides loaded when image completes */
    S.querySelectorAll('.cds-pp__carousel-slide, .cds-pp__slide').forEach(function(slide){
      var img=slide.querySelector('img');
      if(!img)return;
      if(img.complete){slide.classList.add('is-loaded');return;}
      img.addEventListener('load',function(){slide.classList.add('is-loaded')},{once:true});
    });
  }

  /* Zoom */
function initZoom(){
    S.querySelectorAll('.cds-pp__slide.has-zoom, .cds-pp__grid-item').forEach(function(el){
      el.addEventListener('mousemove',function(e){var r=this.getBoundingClientRect();var x=((e.clientX-r.left)/r.width*100).toFixed(1);var y=((e.clientY-r.top)/r.height*100).toFixed(1);this.style.setProperty('--zoom-x',x+'%');this.style.setProperty('--zoom-y',y+'%')});
    });
  }
/* Lightbox */
function initLightbox(){
    var lb=S.querySelector('[data-lightbox]'),img=S.querySelector('[data-lb-img]'),counter=S.querySelector('[data-lb-counter]');
    if(!lb||!img)return;
    var idx=0,total=imgURLs.filter(function(u){return u!==null}).length;
    var validIdx=[];imgURLs.forEach(function(u,i){if(u!==null)validIdx.push(i)});

    function show(i){idx=i;var realIdx=validIdx.indexOf(i);if(realIdx===-1)return;img.src=imgURLs[i];if(counter)counter.textContent=(realIdx+1)+' / '+total;lb.classList.add('is-open');document.body.style.overflow='hidden';document.addEventListener('keydown',lbKeyHandler)}
    function hide(){lb.classList.remove('is-open');document.body.style.overflow='';document.removeEventListener('keydown',lbKeyHandler)}
    function prev(){var ci=validIdx.indexOf(idx);var ni=ci<=0?validIdx.length-1:ci-1;show(validIdx[ni])}
    function next(){var ci=validIdx.indexOf(idx);var ni=ci>=validIdx.length-1?0:ci+1;show(validIdx[ni])}
    function lbKeyHandler(e){if(!lb.classList.contains('is-open'))return;if(e.key==='Escape')hide();if(e.key==='ArrowLeft')prev();if(e.key==='ArrowRight')next()}
    S._lbKeyHandler=lbKeyHandler;S._lbHide=hide;

    S.querySelectorAll('[data-lb-trigger]').forEach(function(el){el.addEventListener('click',function(e){if(e.target.tagName==='VIDEO')return;show(parseInt(this.dataset.lbIndex||this.closest('[data-lb-index]').dataset.lbIndex))})});
    S.querySelectorAll('[data-lb-close]').forEach(function(el){el.addEventListener('click',hide)});
    S.querySelector('[data-lb-prev]').addEventListener('click',prev);
    S.querySelector('[data-lb-next]').addEventListener('click',next);

  }
/* Sold-out state: check which option values have zero available variants */
  function updateSoldOut(){
    S.querySelectorAll('.cds-pp__option').forEach(function(optionEl){
      var oi=parseInt(optionEl.dataset.optionPosition)-1;
      optionEl.querySelectorAll('.cds-pp__option-btn').forEach(function(btn){
        var val=btn.dataset.value;
        /* Check if ANY variant with this value (at this option position) is available */
        var hasAvailable=false;
        for(var i=0;i<PD.variants.length;i++){
          var v=PD.variants[i];
          if(v.options[oi]===val&&v.available){hasAvailable=true;break}
        }
        btn.classList.toggle('is-soldout',!hasAvailable);
      });
      /* Also update dropdown options */
      var dd=optionEl.querySelector('[data-dropdown-option]');
      if(dd){
        Array.prototype.forEach.call(dd.options,function(opt){
          var val=opt.value;if(!val)return;
          var hasAvailable=false;
          for(var i=0;i<PD.variants.length;i++){
            var v=PD.variants[i];
            if(v.options[oi]===val&&v.available){hasAvailable=true;break}
          }
          opt.disabled=!hasAvailable;
          opt.textContent=val+(hasAvailable?'':' (Épuisé)');
        });
      }
    });
  }

  /* Variants */
  function initVariants(){
    var btns=S.querySelectorAll('.cds-pp__option-btn');
    btns.forEach(function(b){b.addEventListener('click',function(){
      var oi=parseInt(this.dataset.optionIndex),v=this.dataset.value;opts[oi]=v;
      this.closest('.cds-pp__option-values').querySelectorAll('.cds-pp__option-btn').forEach(function(s){s.classList.remove('is-active')});this.classList.add('is-active');
      var label=this.closest('.cds-pp__option').querySelector('.cds-pp__option-name strong');if(label)label.textContent=v;
      var dd=this.closest('.cds-pp__option').querySelector('.cds-pp__option-dropdown');if(dd)dd.value=v;
      var variant=findV(opts);if(variant){CV=variant;updateUI(variant)}
      updateSoldOut();
    })});
    /* Dropdown options */
    S.querySelectorAll('[data-dropdown-option]').forEach(function(dd){dd.addEventListener('change',function(){
      var oi=parseInt(this.dataset.optionIndex),v=this.value;opts[oi]=v;
      var label=this.closest('.cds-pp__option').querySelector('.cds-pp__option-name strong');if(label)label.textContent=v;
      var variant=findV(opts);if(variant){CV=variant;updateUI(variant)}
      updateSoldOut();
    })});
  }

  function updateUI(v){
    var inp=S.querySelector('[data-variant-id-input]');if(inp)inp.value=v.id;
    var sel=S.querySelector('[data-variant-select]');if(sel)sel.value=v.id;
    /* Price */
    var pw=S.querySelector('[data-price-wrap]');
    if(pw){var zb=pw.dataset.cdsZeroBehavior||'show';var zt=pw.dataset.cdsZeroText||'';var h='';if(v.price===0&&zb!=='show'){if(zb==='custom'&&zt){h='<span class="cds-pp__price">'+zt+'</span>'}pw.style.display=(zb==='hide')?'none':'';pw.innerHTML=h}else{pw.style.display='';if(v.compare_at_price&&v.compare_at_price>v.price){h+='<span class="cds-pp__price cds-pp__price--compare">'+fmt(v.compare_at_price)+'</span>';h+='<span class="cds-pp__price cds-pp__price--sale">'+fmt(v.price)+'</span>';var p=Math.round((v.compare_at_price-v.price)/v.compare_at_price*100);h+='<span class="cds-pp__badge-sale">-'+p+'%</span>'}else{h+='<span class="cds-pp__price">'+fmt(v.price)+'</span>'}pw.innerHTML=h}}
    /* ATC */
    var btn=S.querySelector('[data-atc-btn]');
    var vbQty=1;var activeVB=S.querySelector('.cds-pp__vb-card.is-active');if(activeVB)vbQty=parseInt(activeVB.dataset.vbQty)||1;
    if(btn){btn.disabled=!v.available;var t=btn.querySelector('[data-atc-text]'),p=btn.querySelector('[data-atc-price]'),sp=btn.querySelector('[data-atc-sep]');if(v.available){if(t)t.textContent=atcT;if(p){p.textContent=fmt(v.price*vbQty);p.style.display=''}if(sp)sp.style.display=''}else{if(t)t.textContent=soldT;if(p)p.style.display='none';if(sp)sp.style.display='none'}}
    /* Volume bundle */
    if(S._updateVB)S._updateVB(v);
    /* Pickup availability */
    if(S._updatePickup)S._updatePickup(v);
    /* Installment */
    if(showI){var ie=S.querySelector('[data-installment]');if(ie)ie.textContent='Payez en '+instC+' fois '+fmt(Math.ceil(v.price/instC))+'. Sans frais.'}
    /* Sticky */
    var sp=S.querySelector('[data-sticky-price]');if(sp){var _zb2=pw?pw.dataset.cdsZeroBehavior||'show':'show';var _zt2=pw?pw.dataset.cdsZeroText||'':'';if(v.price===0&&_zb2!=='show'){sp.textContent=(_zb2==='custom'&&_zt2)?_zt2:'';sp.style.display=(_zb2==='hide')?'none':''}else{sp.style.display='';sp.textContent=fmt(v.price)}}
    /* Image — switch gallery to variant media */
    if(variantMediaMap[v.id]!==undefined){var si=variantMediaMap[v.id];if(S._go)S._go(si);if(S._goMobile)S._goMobile(si)}
    /* URL */
    if(history.replaceState){var u=new URL(location.href);u.searchParams.set('variant',v.id);history.replaceState({},'',u.toString())}
  }

  /* Description */
  function initDesc(){
    var c=S.querySelector('[data-desc-content]'),b=S.querySelector('[data-see-more]');if(!c||!b)return;
    requestAnimationFrame(function(){if(c.scrollHeight<=c.offsetHeight+5){b.style.display='none';c.style.maxHeight='none';c.classList.add('is-expanded')}});
    b.addEventListener('click',function(){var ex=c.classList.toggle('is-expanded');this.textContent=ex?lessT:moreT});
  }

  /* Tabs */
  function initTabs(){
    /* Horizontal tabs */
    var btns=S.querySelectorAll('[data-tab]'),panels=S.querySelectorAll('[data-tab-panel]');
    if(btns.length){btns.forEach(function(b){b.addEventListener('click',function(){var i=this.dataset.tab;btns.forEach(function(x){x.classList.remove('is-active');x.setAttribute('aria-selected','false')});panels.forEach(function(x){x.classList.remove('is-active');x.setAttribute('hidden','')});this.classList.add('is-active');this.setAttribute('aria-selected','true');var p=S.querySelector('[data-tab-panel="'+i+'"]');if(p){p.classList.add('is-active');p.removeAttribute('hidden')}})})}
    /* Vertical tabs (accordion) */
    S.querySelectorAll('[data-vtab-toggle]').forEach(function(t){t.addEventListener('click',function(){var vtab=this.closest('.cds-pp__vtab');vtab.classList.toggle('is-open');this.setAttribute('aria-expanded',vtab.classList.contains('is-open'))})});
  }

  /* Delivery */
  function initDel(){S.querySelectorAll('[data-delivery-toggle]').forEach(function(t){t.addEventListener('click',function(){this.closest('.cds-pp__delivery').classList.toggle('is-open')})})}

  /* Size guide modal */
  function initSizeGuide(){
    var open=S.querySelector('[data-sg-open]'),overlay=S.querySelector('[data-sg-overlay]'),close=S.querySelector('[data-sg-close]');
    if(!open||!overlay)return;
    /* Teleport overlay to section root to escape stacking context */
    S.appendChild(overlay);
    /* Move trigger to "Taille"/"Size" option header if present */
    var sizeOption=S.querySelector('[data-option-size] .cds-pp__option-header');
    if(sizeOption&&open){sizeOption.appendChild(open);var sgWrap=S.querySelector('.cds-pp__size-guide');if(sgWrap&&!sgWrap.children.length)sgWrap.style.display='none';}
    function sgKeyHandler(e){if(e.key==='Escape'&&overlay.classList.contains('is-open'))shut()}
    open.addEventListener('click',function(){overlay.classList.add('is-open');document.body.style.overflow='hidden';document.addEventListener('keydown',sgKeyHandler)});
    function shut(){overlay.classList.remove('is-open');document.body.style.overflow='';document.removeEventListener('keydown',sgKeyHandler)}
    if(close)close.addEventListener('click',shut);
    overlay.addEventListener('click',function(e){if(e.target===overlay)shut()});
    S._sgKeyHandler=sgKeyHandler;S._sgShut=shut;
  }

  /* Qty */
  function initQty(){
    var m=S.querySelector('[data-qty-minus]'),p=S.querySelector('[data-qty-plus]'),i=S.querySelector('[data-qty-input]');if(!m||!p||!i)return;
    m.addEventListener('click',function(){var v=parseInt(i.value)||1;if(v>1)i.value=v-1});
    p.addEventListener('click',function(){i.value=(parseInt(i.value)||1)+1});
  }

  /* Volume Bundle */
  function initVolumeBundle(){
    var wrap=S.querySelector('[data-volume-bundle]');if(!wrap)return;
    var cards=wrap.querySelectorAll('[data-vb-card]');
    var extras=S.querySelector('[data-vb-extras]');
    var qtyInput=S.querySelector('[data-qty-input]');
    if(!cards.length||!qtyInput)return;

    /* Store extra variant selections: {1: variantId, 2: variantId} (0-indexed extra articles) */
    S._vbExtraVariants=[];

    /* Build options data from product */
    var optionNames=PD.options||[];

    /* Check if any available variant exists with optionValue at optionIndex */
    function hasAvailableVariant(optionIndex,optionValue){
      for(var i=0;i<PD.variants.length;i++){
        if(PD.variants[i].options[optionIndex]===optionValue&&PD.variants[i].available)return true;
      }
      return false;
    }

    function buildExtraRow(articleIdx){
      var row=document.createElement('div');
      row.className='cds-pp__vb-extra-row';
      row.dataset.vbExtraIdx=articleIdx;
      var label=document.createElement('span');
      label.className='cds-pp__vb-extra-label';
      label.textContent='Article '+(articleIdx+2);
      row.appendChild(label);
      var selWrap=document.createElement('div');
      selWrap.className='cds-pp__vb-extra-selects';

      /* For each option, create a select */
      for(var oi=0;oi<optionNames.length;oi++){
        var sel=document.createElement('select');
        sel.className='cds-pp__vb-extra-select';
        sel.dataset.optionIndex=oi;
        sel.dataset.extraIdx=articleIdx;
        /* Collect unique values for this option */
        var vals=[];
        for(var vi=0;vi<PD.variants.length;vi++){
          var val=PD.variants[vi].options[oi];
          if(vals.indexOf(val)===-1)vals.push(val);
        }
        for(var j=0;j<vals.length;j++){
          var opt=document.createElement('option');
          opt.value=vals[j];
          var available=hasAvailableVariant(oi,vals[j]);
          opt.textContent=vals[j]+(available?'':' — Épuisé');
          opt.disabled=!available;
          /* Default to same as main variant */
          if(CV&&CV.options[oi]===vals[j]&&available)opt.selected=true;
          sel.appendChild(opt);
        }
        sel.addEventListener('change',function(){
          var idx=parseInt(this.dataset.extraIdx);
          updateSelectAvailability(idx);
          syncExtraVariant(idx);
        });
        selWrap.appendChild(sel);
      }
      row.appendChild(selWrap);
      /* Add out-of-stock indicator */
      var oos=document.createElement('span');
      oos.className='cds-pp__vb-extra-oos';
      oos.style.display='none';
      oos.textContent='Combinaison épuisée';
      row.appendChild(oos);
      return row;
    }

    /* Update option availability based on currently selected options in a row */
    function updateSelectAvailability(idx){
      var row=S.querySelector('.cds-pp__vb-extra-row[data-vb-extra-idx="'+idx+'"]');if(!row)return;
      var sels=row.querySelectorAll('.cds-pp__vb-extra-select');
      /* Get currently selected values */
      var selected=[];
      for(var i=0;i<sels.length;i++)selected.push(sels[i].value);

      /* For each select, update which options are available given the OTHER selected values */
      for(var si=0;si<sels.length;si++){
        var sel=sels[si];
        var opts=sel.querySelectorAll('option');
        for(var oi=0;oi<opts.length;oi++){
          var testVal=opts[oi].value;
          /* Check: is there any available variant with this value AND the other selected values? */
          var canSelect=false;
          for(var vi=0;vi<PD.variants.length;vi++){
            var v=PD.variants[vi];
            if(!v.available)continue;
            if(v.options[si]!==testVal)continue;
            /* Check other options match */
            var match=true;
            for(var k=0;k<sels.length;k++){
              if(k===si)continue;
              if(v.options[k]!==selected[k]){match=false;break}
            }
            if(match){canSelect=true;break}
          }
          var cleanLabel=opts[oi].value;
          opts[oi].textContent=cleanLabel+(canSelect?'':' — Épuisé');
          opts[oi].disabled=!canSelect;
        }
      }
    }

    function syncExtraVariant(idx){
      /* Read selected options for this extra article row */
      var row=S.querySelector('.cds-pp__vb-extra-row[data-vb-extra-idx="'+idx+'"]');if(!row)return;
      var sels=row.querySelectorAll('.cds-pp__vb-extra-select');
      var selOpts=[];
      for(var i=0;i<sels.length;i++)selOpts.push(sels[i].value);
      /* Find matching variant */
      var v=findV(selOpts);
      S._vbExtraVariants[idx]=v?v.id:null;
      /* Show/hide out-of-stock indicator */
      var oos=row.querySelector('.cds-pp__vb-extra-oos');
      if(oos){
        if(v&&v.available){oos.style.display='none';row.classList.remove('is-oos')}
        else{oos.style.display='';row.classList.add('is-oos')}
      }
      updateVBTotalPrice();
    }

    /* Discount percentages from settings */
    var _discounts={1:0,2:parseInt(wrap.dataset.vbDisc2)||0,3:parseInt(wrap.dataset.vbDisc3)||0};

    function _calcCardTotal(q){
      var t=CV?CV.price:0;
      for(var j=0;j<q-1;j++){
        var xid=S._vbExtraVariants[j];
        var xv=xid?findById(xid):CV;
        t+=(xv?xv.price:(CV?CV.price:0));
      }
      return t;
    }

    function updateVBTotalPrice(){
      var active=wrap.querySelector('.cds-pp__vb-card.is-active');
      if(!active)return;
      var qty=parseInt(active.dataset.vbQty)||1;
      var disc=_discounts[qty]||0;
      var total=_calcCardTotal(qty);
      var discountedTotal=disc>0?Math.round(total*(100-disc)/100):total;

      /* Update each card's displayed prices */
      cards.forEach(function(card){
        var q=parseInt(card.dataset.vbQty)||1;
        var priceWrap=card.querySelector('[data-vb-price]');
        if(!priceWrap)return;
        var d=_discounts[q]||0;
        var fullPrice=_calcCardTotal(q);
        var finalPrice=d>0?Math.round(fullPrice*(100-d)/100):fullPrice;

        /* Compare (strikethrough) price */
        var compareEl=priceWrap.querySelector('[data-vb-compare]');
        var priceEl=priceWrap.querySelector('.cds-pp__vb-price');
        if(d>0){
          if(!compareEl){
            compareEl=document.createElement('span');
            compareEl.className='cds-pp__vb-compare';
            compareEl.setAttribute('data-vb-compare','');
            priceWrap.insertBefore(compareEl,priceEl);
          }
          compareEl.textContent=fmt(fullPrice);
          compareEl.style.display='';
          if(priceEl){priceEl.textContent=fmt(finalPrice);priceEl.classList.add('has-discount')}
        }else{
          if(compareEl)compareEl.style.display='none';
          if(priceEl){priceEl.textContent=fmt(fullPrice);priceEl.classList.remove('has-discount')}
        }
      });
      /* Update ATC price (shows discounted price of active card) */
      var atcPrice=S.querySelector('[data-atc-price]');
      if(atcPrice)atcPrice.textContent=fmt(discountedTotal);
    }

    function _isMobile(){return window.innerWidth<=991}

    function renderExtras(qty){
      /* Clear extras from both containers */
      if(extras){extras.innerHTML='';extras.classList.remove('is-visible')}
      var inlineRows=wrap.querySelectorAll('.cds-pp__vb-extra-row');
      for(var r=0;r<inlineRows.length;r++)inlineRows[r].remove();
      S._vbExtraVariants=[];
      if(qty<=1)return;
      if(_isMobile()){
        /* Mobile: all extras grouped right below the active card */
        var activeCard=wrap.querySelector('[data-vb-qty="'+qty+'"]');
        if(activeCard){
          var ref=activeCard;
          for(var i=0;i<qty-1;i++){
            var row=buildExtraRow(i);
            ref.insertAdjacentElement('afterend',row);
            ref=row;
            S._vbExtraVariants[i]=CV?CV.id:null;
            syncExtraVariant(i);
          }
        }
      }else{
        /* Desktop: extras in separate container */
        for(var i=0;i<qty-1;i++){
          extras.appendChild(buildExtraRow(i));
          S._vbExtraVariants[i]=CV?CV.id:null;
          syncExtraVariant(i);
        }
        extras.classList.add('is-visible');
      }
    }

    cards.forEach(function(card){
      card.addEventListener('click',function(){
        cards.forEach(function(c){c.classList.remove('is-active')});
        card.classList.add('is-active');
        var qty=parseInt(card.dataset.vbQty)||1;
        qtyInput.value=qty;
        renderExtras(qty);
        updateVBTotalPrice();
      });
    });

    /* Re-layout extras on mobile/desktop breakpoint change */
    var _lastMob=_isMobile();
    window.addEventListener('resize',function(){
      var mob=_isMobile();
      if(mob!==_lastMob){
        _lastMob=mob;
        var ac=wrap.querySelector('.cds-pp__vb-card.is-active');
        if(ac)renderExtras(parseInt(ac.dataset.vbQty)||1);
      }
    });

    /* Expose for variant changes from main picker */
    S._updateVB=function(v){
      if(!v)return;
      wrap.dataset.variantPrice=v.price;
      updateVBTotalPrice();
    };

    /* Expose for ATC — returns array of {id, quantity} items */
    S._getVBItems=function(){
      var active=wrap.querySelector('.cds-pp__vb-card.is-active');
      if(!active)return null;
      var qty=parseInt(active.dataset.vbQty)||1;
      if(qty<=1)return null; /* Single item → use normal flow */
      var items=[];
      items.push({id:CV?CV.id:null,quantity:1});
      for(var i=0;i<qty-1;i++){
        var vid=S._vbExtraVariants[i];
        items.push({id:vid||(CV?CV.id:null),quantity:1});
      }
      return items;
    };
  }

  /* Custom checkbox sync — enable/disable hidden fallback based on checkbox state */
  function initCustomCheckboxes(){
    var form=S.querySelector('[data-product-form]');
    var checkboxes=S.querySelectorAll('[data-custom-checkbox]');
    checkboxes.forEach(function(cb){
      var hidden=cb.closest('.cds-pp__cf-checkbox').querySelector('input[type=hidden]');
      if(hidden){
        hidden.disabled=!cb.checked;
        cb.addEventListener('change',function(){hidden.disabled=!cb.checked});
      }
    });
  }

  /* Gift card recipient form */
  function initRecipientForm(){
    var gcr=S.querySelector('[data-gcr]');if(!gcr)return;
    var cb=gcr.querySelector('[data-gcr-checkbox]');
    var fields=gcr.querySelector('[data-gcr-fields]');
    var inputs=gcr.querySelectorAll('[data-gcr-input]');
    var control=gcr.querySelector('[data-gcr-control]');
    var offset=gcr.querySelector('[data-gcr-offset]');
    var message=gcr.querySelector('[data-gcr-message]');
    var charCount=gcr.querySelector('[data-gcr-char-count]');
    var sendOn=gcr.querySelector('[data-gcr-send-on]');
    if(!cb||!fields)return;

    /* Set date constraints: min = today, max = today + 90 days */
    function setDateConstraints(){
      if(!sendOn)return;
      var today=new Date();
      var max=new Date();max.setDate(today.getDate()+90);
      function pad(n){return n<10?'0'+n:n}
      function fmtDate(d){return d.getFullYear()+'-'+pad(d.getMonth()+1)+'-'+pad(d.getDate())}
      sendOn.setAttribute('min',fmtDate(today));
      sendOn.setAttribute('max',fmtDate(max));
    }
    setDateConstraints();

    /* Character count */
    function updateCharCount(){
      if(!message||!charCount)return;
      charCount.textContent=message.value.length+' / '+message.maxLength;
    }
    if(message)message.addEventListener('input',updateCharCount);

    /* Toggle */
    cb.addEventListener('change',function(){
      if(cb.checked){
        fields.classList.add('is-visible');
        inputs.forEach(function(inp){inp.disabled=false});
        if(control)control.disabled=false;
        if(offset){offset.disabled=false;offset.value=new Date().getTimezoneOffset().toString()}
        /* Set email as required */
        var email=gcr.querySelector('[data-gcr-email]');if(email)email.setAttribute('required','required');
        updateCharCount();
      }else{
        fields.classList.remove('is-visible');
        inputs.forEach(function(inp){
          inp.disabled=true;
          inp.value='';
          inp.removeAttribute('aria-invalid');
          inp.style.borderColor='';
        });
        if(control)control.disabled=true;
        if(offset){offset.disabled=true;offset.value=''}
        var email=gcr.querySelector('[data-gcr-email]');if(email)email.removeAttribute('required');
        updateCharCount();
      }
    });

    /* Expose validation check */
    S._validateRecipient=function(){
      if(!cb.checked)return true; /* not sending to recipient, skip */
      var email=gcr.querySelector('[data-gcr-email]');
      if(!email||!email.value||!email.value.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)){
        if(email){email.style.borderColor='red';email.focus()}
        return false;
      }
      email.style.borderColor='';
      return true;
    };
  }

  /* ========================================
     ATC System — Horizon-compatible
     ======================================== */

  /* Collect cart-drawer section IDs for Shopify Section Rendering API */
  function cartSectionIds(){
    var ids=[];
    document.querySelectorAll('cart-items-component[data-section-id]').forEach(function(el){
      if(el.dataset.sectionId) ids.push(el.dataset.sectionId);
    });
    return ids;
  }

  /* Dispatch cart:update matching Horizon's CartAddEvent structure exactly.
     CartAddEvent extends Event (NOT CustomEvent) and assigns detail as own property.
     Reference: assets/events.js lines 91-116 */
  function dispatchCartUpdate(sections, productId, qty){
    var evt=new Event('cart:update',{bubbles:true});
    evt.detail={
      resource:{},
      sourceId:'cds-product-page',
      data:{
        source:'cds-product-page',
        productId:productId,
        itemCount:qty,
        sections:sections||{}
      }
    };
    document.dispatchEvent(evt);
  }

  /* Open the cart drawer. If auto-open is enabled on cart-drawer-component,
     the cart:update event already triggered showDialog() — so we skip.
     Otherwise we click the native trigger button (most reliable). */
  function openCartDrawer(){
    var drawer=document.querySelector('cart-drawer-component');
    if(!drawer){
      window.location.href=(window.Theme&&Theme.routes&&Theme.routes.cart_url)||'/cart';
      return;
    }
    function _tryOpen(){
      var trigger=document.querySelector('[data-testid="cart-drawer-trigger"]');
      if(trigger){trigger.click();return}
      if(typeof drawer.showDialog==='function'){drawer.showDialog();return}
      if(typeof drawer.open==='function'){drawer.open();return}
    }
    if(drawer.hasAttribute('auto-open')){
      /* Auto-open should handle via cart:update event — verify with fallback */
      setTimeout(function(){
        if(!drawer.hasAttribute('open')&&!drawer.open)_tryOpen();
      },350);
      return;
    }
    _tryOpen();
  }

  /* Add to cart via AJAX — called by both main form and upsell */
  function addToCart(fd, onSuccess, onError){
    var variantId=fd.get('id');
    var qty=fd.get('quantity')||'1';

    /* Collect properties (custom fields) */
    var props={};
    for(var pair of fd.entries()){
      if(pair[0].indexOf('properties[')===0){
        var key=pair[0].replace('properties[','').replace(']','');
        props[key]=pair[1];
      }
    }

    /* Build JSON payload */
    var payload={id:parseInt(variantId),quantity:parseInt(qty)};
    if(Object.keys(props).length)payload.properties=props;
    var sids=cartSectionIds();
    if(sids.length)payload.sections=sids.join(',');

    fetch('/cart/add.js',{
      method:'POST',
      headers:{'Content-Type':'application/json','X-Requested-With':'XMLHttpRequest'},
      body:JSON.stringify(payload)
    })
    .then(function(r){
      if(!r.ok) return r.json().then(function(e){throw e},function(){throw{status:r.status,message:'Request failed ('+r.status+')'}});
      return r.json();
    })
    .then(function(d){
      if(d.status&&d.status>=400){onError(d.description||d.message||'Error');return}
      var q=parseInt(qty)||1;
      onSuccess(d,q);
      try{cartCount()}catch(e){}
      try{if(typeof initShipBar==='function')initShipBar()}catch(e){}
      dispatchCartUpdate(d.sections||{},d.product_id,q);
      openCartDrawer();
    })
    .catch(function(err){
      var msg=err&&err.description||err&&err.message||'Network error';
      onError(msg);
    });
  }

  /* Add multiple items (volume bundle with different variants) */
  function addMultiItems(items, props, onSuccess, onError){
    var sids=cartSectionIds();
    var itemsPayload=items.map(function(it){
      var o={id:parseInt(it.id),quantity:parseInt(it.quantity)||1};
      /* Merge global props + per-item properties (bundle note) */
      var merged={};
      if(Object.keys(props).length){for(var k in props)merged[k]=props[k]}
      if(it.properties){for(var k2 in it.properties)merged[k2]=it.properties[k2]}
      if(Object.keys(merged).length)o.properties=merged;
      return o;
    });
    var payload={items:itemsPayload};
    if(sids.length)payload.sections=sids.join(',');

    fetch('/cart/add.js',{
      method:'POST',
      headers:{'Content-Type':'application/json','X-Requested-With':'XMLHttpRequest'},
      body:JSON.stringify(payload)
    })
    .then(function(r){
      if(!r.ok) return r.json().then(function(e){throw e},function(){throw{status:r.status,message:'Request failed ('+r.status+')'}});
      return r.json();
    })
    .then(function(d){
      if(d.status&&d.status>=400){onError(d.description||d.message||'Error');return}
      var totalQty=items.reduce(function(s,it){return s+(parseInt(it.quantity)||1)},0);
      onSuccess(d,totalQty);
      try{cartCount()}catch(e){}
      try{if(typeof initShipBar==='function')initShipBar()}catch(e){}
      dispatchCartUpdate(d.sections||{},d.items?d.items[0].product_id:null,totalQty);
      openCartDrawer();
    })
    .catch(function(err){
      onError(err&&err.description||err&&err.message||'Network error');
    });
  }

  function initForm(){
    var form=S.querySelector('[data-product-form]');
    if(!form)return;
    form.addEventListener('submit',function(e){
      e.preventDefault();
      var btn=S.querySelector('[data-atc-btn]');
      if(!btn||btn.disabled)return;
      /* Validate required custom fields */
      var missing=false;
      S.querySelectorAll('[data-cf-input][required]').forEach(function(f){
        if(!f.value||f.value===''){f.style.borderColor='red';missing=true}else{f.style.borderColor=''}
      });
      if(missing)return;
      /* Validate gift card recipient if enabled */
      if(S._validateRecipient&&!S._validateRecipient())return;
      /* Validate required bundle pickers */
      var bundleErr=S._validateBundles?S._validateBundles():null;
      if(bundleErr)return;
      var orig=btn.innerHTML;
      btn.disabled=true;
      btn.innerHTML='<span class="cds-pp__spinner"></span>';
      /* Collect custom field properties */
      var props={};
      S.querySelectorAll('[data-cf-input]').forEach(function(f){
        var n=f.name;
        if(n&&n.indexOf('properties[')===0){
          var key=n.replace('properties[','').replace(']','');
          if(f.type==='checkbox'){if(f.checked)props[key]=f.value}
          else if(f.value)props[key]=f.value;
        }
      });
      /* Collect gift card recipient properties (if enabled) */
      S.querySelectorAll('[data-gcr-input]:not(:disabled),[data-gcr-control]:not(:disabled),[data-gcr-offset]:not(:disabled)').forEach(function(f){
        var n=f.name;
        if(n&&n.indexOf('properties[')===0){
          var key=n.replace('properties[','').replace(']','');
          if(f.value)props[key]=f.value;
        }
      });

      /* Inline error message */
      function showFormError(msg){
        var el=S.querySelector('[data-vb-form-error]');
        if(!el){
          el=document.createElement('div');
          el.setAttribute('data-vb-form-error','');
          el.style.cssText='padding:8px 12px;margin-top:6px;border-radius:8px;font-size:12px;font-weight:500;color:#c0392b;background:rgba(192,57,43,0.06);border:1px solid rgba(192,57,43,0.15);text-align:center;';
          btn.parentElement.insertAdjacentElement('afterend',el);
        }
        el.textContent=msg;el.style.display='';
        setTimeout(function(){el.style.display='none'},5000);
      }

      var successCb=function(d,qty){
        btn.disabled=false;
        btn.innerHTML='<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" style="vertical-align:-2px"><polyline points="20 6 9 17 4 12"/></svg> Ajouté !';
        btn.classList.add('is-success');setTimeout(function(){btn.classList.remove('is-success');btn.innerHTML=orig},1500);
        var errEl=S.querySelector('[data-vb-form-error]');if(errEl)errEl.style.display='none';
        try{toast()}catch(e){}
      };
      var failCb=function(msg){
        btn.disabled=false;btn.innerHTML=orig;
        showFormError(msg);
      };

      /* Check volume bundle multi-items */
      var vbItems=S._getVBItems?S._getVBItems():null;
      if(vbItems&&vbItems.length>1){
        /* Pre-validate stock for each variant */
        var countByV={};
        for(var vi=0;vi<vbItems.length;vi++){
          var vid=String(vbItems[vi].id);
          countByV[vid]=(countByV[vid]||0)+1;
        }
        var stockErr=null;
        for(var svid in countByV){
          var sv=findById(parseInt(svid));
          if(sv&&sv.inventory_management&&sv.inventory_policy!=='continue'){
            if(sv.inventory_quantity<countByV[svid]){
              var avail=sv.inventory_quantity>0?sv.inventory_quantity:0;
              stockErr='Stock insuffisant pour « '+sv.title+' » — '+avail+' disponible'+(avail>1?'s':'');
              break;
            }
          }
        }
        if(stockErr){btn.disabled=false;btn.innerHTML=orig;showFormError(stockErr);return}
        /* Append bundle picker items to volume bundle */
        var _parentTitle=(S.querySelector('.cds-product__title')||S.querySelector('h1')||{}).textContent||'';
        _parentTitle=_parentTitle.trim();
        var _bNum=S._getBundleNumber(_parentTitle);
        var _bLabel=_parentTitle+' '+_bNum;
        var bpItems=S._getBundleItems?S._getBundleItems(S._generateBundleGroupId(),_bLabel):[];
        if(bpItems.length){
          var bgId=bpItems[0].properties['_bundle_group'];
          vbItems[0].properties=vbItems[0].properties||{};
          vbItems[0].properties['_bundle_group']=bgId;
          vbItems[0].properties['_bundle_role']='parent';
          bpItems.forEach(function(bp){vbItems.push(bp)});
        }
        addMultiItems(vbItems,props,successCb,failCb);
      }else{
        /* Standard single item add — check for bundle picker items */
        var bundleGrpId=S._generateBundleGroupId();
        var _pTitle=(S.querySelector('.cds-product__title')||S.querySelector('h1')||{}).textContent||'';
        _pTitle=_pTitle.trim();
        var _bNum2=S._getBundleNumber(_pTitle);
        var _bLabel2=_pTitle+' '+_bNum2;
        var bpItems2=S._getBundleItems?S._getBundleItems(bundleGrpId,_bLabel2):[];
        if(bpItems2.length){
          /* Build multi-items: main product (parent FIRST) + bundle items (children) */
          var mainVid=form.querySelector('[data-variant-id-input]')||form.querySelector('[name="id"]');
          var mainQty=form.querySelector('[data-qty-input]')||form.querySelector('[name="quantity"]');
          var mainItem={id:parseInt(mainVid.value),quantity:parseInt(mainQty?mainQty.value:1)||1};
          mainItem.properties=mainItem.properties||{};
          mainItem.properties['_bundle_group']=bundleGrpId;
          mainItem.properties['_bundle_role']='parent';
          var allItems=[mainItem];
          bpItems2.forEach(function(bp){allItems.push(bp)});
          addMultiItems(allItems,props,function(d,qty){
            successCb(d,qty);
            /* Reset all bundle pickers */
            (S._bundlePickers||[]).forEach(function(pk){
              pk.items=[];
              var slots=pk.el.querySelectorAll('[data-bp-slot]');
              slots.forEach(function(slot,i){
                var card=slot.querySelector('[data-bp-slot-card]');
                card.classList.remove('has-product');
                card.innerHTML='<div class="cds-pp__bp-slot-plus"><svg viewBox="0 0 24 24" fill="none" stroke-linecap="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg></div>';
                var label=slot.querySelector('.cds-pp__bp-slot-label');
                if(label){label.classList.remove('has-product');label.textContent='Produit '+(i+1)}
                var oldP=slot.querySelector('.cds-pp__bp-slot-price');if(oldP)oldP.remove();
                var oldQ=slot.querySelector('.cds-pp__bp-slot-qty');if(oldQ)oldQ.remove();
              });
              var counter=pk.el.querySelector('[data-bp-counter]');if(counter)counter.style.display='none';
              var subEl=pk.el.querySelector('[data-bp-subtotal]');if(subEl)subEl.classList.remove('is-visible');
            });
          },failCb);
        }else{
          var fd=new FormData(form);
          S.querySelectorAll('[data-cf-input]').forEach(function(f){
            var n=f.name;
            if(f.type==='checkbox'){if(f.checked)fd.set(n,f.value)}
            else if(f.value)fd.set(n,f.value)
          });
          /* Add gift card recipient fields to FormData */
          S.querySelectorAll('[data-gcr-input]:not(:disabled),[data-gcr-control]:not(:disabled),[data-gcr-offset]:not(:disabled)').forEach(function(f){
            if(f.name&&f.value)fd.set(f.name,f.value);
          });
          addToCart(fd,successCb,failCb);
        }
      }
    });
  }

  /* Upsell variant selector change */
  S.addEventListener('change', function(e){
    var sel=e.target.closest('[data-upsell-variant-select]');
    if(!sel)return;
    var item=sel.closest('.cds-pp__upsell-item');if(!item)return;
    var opt=sel.options[sel.selectedIndex];
    var addBtn=item.querySelector('[data-upsell-add]');
    if(addBtn)addBtn.dataset.variantId=sel.value;
    var priceEl=item.querySelector('[data-up-price]');
    if(priceEl&&opt.dataset.price)priceEl.textContent=fmt(parseInt(opt.dataset.price));
  });

  /* Pickup availability — update on variant change */
  function initPickup(){
    var el=S.querySelector('[data-pickup]');if(!el)return;
    var productUrl=el.dataset.productUrl;
    var sectionId=el.dataset.sectionId;
    var _abortCtrl=null;
    S._updatePickup=function(v){
      if(!v||!v.available){
        var c=el.querySelector('[data-pickup-content]');
        if(c){c.classList.add('cds-pp__pickup-row--empty');c.innerHTML=''}
        return;
      }
      if(_abortCtrl)_abortCtrl.abort();
      _abortCtrl=new AbortController();
      fetch(productUrl+'?variant='+v.id+'&section_id='+sectionId,{signal:_abortCtrl.signal})
        .then(function(r){return r.text()})
        .then(function(html){
          var doc=new DOMParser().parseFromString(html,'text/html');
          var fresh=doc.querySelector('[data-pickup] [data-pickup-content]');
          var old=el.querySelector('[data-pickup-content]');
          if(fresh&&old){old.replaceWith(fresh)}
          else if(old){old.classList.add('cds-pp__pickup-row--empty');old.innerHTML=''}
        })
        .catch(function(){});
    };
  }

  /* Gift wrap toggle */
  function initGiftWrapToggle(){
    var gw=S.querySelector('[data-gw]');if(!gw)return;
    var cb=gw.querySelector('[data-gw-checkbox]');
    var items=gw.querySelector('[data-gw-items]');
    if(!cb||!items)return;
    cb.addEventListener('change',function(){
      if(cb.checked){items.classList.add('is-visible')}
      else{items.classList.remove('is-visible')}
    });
  }

  /* Upsell */
  function initUpsell(){
    S.querySelectorAll('[data-upsell-add]').forEach(function(b){
      if(b._upsellBound)return;b._upsellBound=true;
      b.addEventListener('click',function(){
        var vid=this.dataset.variantId,btn=this,ot=btn.textContent;
        btn.disabled=true;btn.textContent='...';
        var fd=new FormData();
        fd.append('id',vid);
        fd.append('quantity','1');
        addToCart(fd,
          function onOK(d,qty){
            btn.disabled=false;btn.textContent='✓';btn.classList.add('is-added');
            try{toast()}catch(e){}
            setTimeout(function(){btn.textContent=ot;btn.classList.remove('is-added')},2500);
          },
          function onFail(msg){
            btn.disabled=false;btn.textContent='Erreur';
            console.error('CDS Upsell:',msg);
            setTimeout(function(){btn.textContent=ot},2000);
          }
        );
      });
    });
  }

  /* Countdown */
function initCountdown(){
    var el=S.querySelector('[data-countdown]');if(!el)return;
    var cutoff=parseInt(el.dataset.cutoff),days=parseInt(el.dataset.days);
    function upd(){
      var now=new Date(),end=new Date(now);end.setHours(cutoff,0,0,0);
      if(now>=end)end.setDate(end.getDate()+1);
      var diff=end-now,h=Math.floor(diff/36e5),m=Math.floor((diff%36e5)/6e4);
      var te=el.querySelector('[data-countdown-time]');if(te)te.textContent=h+' h '+m+' min';
      var dd=new Date(end);dd.setDate(dd.getDate()+days);
      while(dd.getDay()===0||dd.getDay()===6)dd.setDate(dd.getDate()+1);
      var de=el.querySelector('[data-countdown-date]');if(de)de.textContent=dd.toLocaleDateString('fr-FR',{weekday:'long',day:'numeric',month:'long'});
    }
    upd();setInterval(upd,6e4);
  }
/* Wishlist */
function initWishlist(){
    var btn=S.querySelector('[data-wishlist]');if(!btn)return;
    var notif=btn.querySelector('[data-wl-notif]');
    var ph=btn.dataset.productHandle,wl=JSON.parse(localStorage.getItem('cds_wishlist')||'[]');
    if(wl.indexOf(ph)!==-1)btn.classList.add('is-active');
    function showNotif(msg){if(!notif)return;notif.textContent=msg;notif.classList.add('is-visible');setTimeout(function(){notif.classList.remove('is-visible')},1800)}
    btn.addEventListener('click',function(){var i=wl.indexOf(ph);if(i===-1){wl.push(ph);btn.classList.add('is-active');showNotif('Ajouté aux favoris')}else{wl.splice(i,1);btn.classList.remove('is-active');showNotif('Retiré des favoris')}localStorage.setItem('cds_wishlist',JSON.stringify(wl));document.dispatchEvent(new Event('cds:wishlist:updated'))});
  }
/* Search & Discovery upsell */
  function initSDUpsell(){
    var el=S.querySelector('[data-sd-upsell]');if(!el)return;
    var pid=el.dataset.productId,container=el.querySelector('[data-sd-items]'),title=el.querySelector('[data-upsell-title]');
    fetch('/recommendations/products.json?product_id='+pid+'&limit=3&intent=complementary')
    .then(function(r){return r.json()}).then(function(data){
      var products=data.products||[];
      if(!products.length){if(title)title.style.display='none';return}
      if(title)title.style.display='';
      products.forEach(function(p){
        var firstAvail=p.variants.find(function(vr){return vr.available || !vr.inventory_management || vr.inventory_policy === 'continue'})||p.variants[0];
        var v=firstAvail;
        var img=p.featured_image?p.featured_image.replace(/(\.[^.]+)$/,'_120x$1'):'';
        var safeTitle=escapeHtml(p.title),safeUrl=escapeHtml(p.url);
        var item=document.createElement('div');item.className='cds-pp__upsell-item';
        var variantSelectHtml='';
        if(p.variants.length>1){
          variantSelectHtml='<div class="cds-pp__up-variant-row"><select class="cds-pp__up-variant-select" data-upsell-variant-select>';
          p.variants.forEach(function(vr){
            var sel=vr.id===v.id?' selected':'';
            var vrAvail=vr.available || !vr.inventory_management || vr.inventory_policy === 'continue';
            var dis=!vrAvail?' disabled':'';
            var soldLabel=!vrAvail?' (Épuisé)':'';
            variantSelectHtml+='<option value="'+vr.id+'" data-price="'+vr.price+'" data-available="'+(vrAvail?'true':'false')+'"'+sel+dis+'>'+escapeHtml(vr.title)+soldLabel+'</option>';
          });
          variantSelectHtml+='</select></div>';
        }
        item.innerHTML='<div class="cds-pp__up-img">'+(img?'<img src="'+escapeHtml(img)+'" alt="'+safeTitle+'" loading="lazy" width="52" height="52">':'')+'</div><div class="cds-pp__up-info"><a href="'+safeUrl+'" class="cds-pp__up-name">'+safeTitle+'</a><span class="cds-pp__up-price" data-up-price>'+fmt(v.price)+'</span></div><button type="button" class="cds-pp__up-add" data-upsell-add data-variant-id="'+v.id+'">'+cfg.upsellBtnText+'</button>'+variantSelectHtml;
        container.appendChild(item);
      });
      initUpsell();
    }).catch(function(){if(title)title.style.display='none'});
  }

  /* Smart sticky — shorter column gets sticky */
  var _smartStickyResizeHandler=null;
  function initSmartSticky(){
    var w=S.querySelector('.cds-pp__wrapper');if(!w)return;
    var g=w.querySelector('.cds-pp__gallery'),info=w.querySelector('.cds-pp__info');
    if(!g||!info)return;
    function update(){
      g.classList.remove('is-sticky');info.classList.remove('is-sticky');
      var gh=g.offsetHeight,ih=info.offsetHeight,wh=window.innerHeight;
      if(window.innerWidth<991)return;
      if(gh<ih&&gh<=wh){g.classList.add('is-sticky')}else if(ih<gh&&ih<=wh){info.classList.add('is-sticky')}
    }
    _smartStickyResizeHandler=function(){update();if(S._syncGalleryHeight)S._syncGalleryHeight()};
    update();window.addEventListener('resize',_smartStickyResizeHandler);
    /* Recalculate when collapsibles open/close */
    S.addEventListener('click',function(e){if(e.target.closest('[data-delivery-toggle]')||e.target.closest('[data-vtab-toggle]')||e.target.closest('[data-bp-toggle]'))setTimeout(update,400)});
  }

  /* Shipping bar */
function initShipBar(){
    var bar=S.querySelector('[data-ship-bar]');if(!bar)return;
    var threshold=parseFloat(bar.dataset.threshold)*100;
    fetch('/cart.js').then(function(r){return r.json()}).catch(function(){return null}).then(function(cart){if(!cart)return;
      var total=cart.total_price,pct=Math.min(100,total/threshold*100);
      var fill=bar.querySelector('[data-ship-fill]');if(fill)fill.style.width=pct+'%';
      var txt=bar.querySelector('[data-ship-text]');
      if(txt){if(total>=threshold){txt.innerHTML='<strong>Livraison gratuite</strong> débloquée !'}else{var remaining=fmt(threshold-total);txt.innerHTML='Plus que <strong>'+remaining+'</strong> pour la livraison gratuite'}}
    });
  }
/* Sticky ATC */
  function initSticky(){
    var bar=S.querySelector('[data-sticky-bar]'),btn=S.querySelector('[data-sticky-atc]'),main=S.querySelector('[data-atc-btn]');
    if(!bar||!main)return;
    var obs=new IntersectionObserver(function(e){e.forEach(function(en){bar.classList.toggle('is-visible',!en.isIntersecting)})},{threshold:0});obs.observe(main);
    if(btn)btn.addEventListener('click',function(){var form=S.querySelector('form[data-product-form]')||main.closest('form');if(form){form.requestSubmit?form.requestSubmit():form.dispatchEvent(new Event('submit',{bubbles:true}))}});
  }

  /* Toast */
  function toast(){var t=S.querySelector('[data-toast]');if(!t)return;t.classList.add('is-visible');setTimeout(function(){t.classList.remove('is-visible')},3000)}

  /* Cart count */
  function cartCount(){fetch('/cart.js').then(function(r){return r.json()}).then(function(c){document.querySelectorAll('.cart-count,[data-cart-count],.cds-hg__badge').forEach(function(e){e.textContent=c.item_count;if(c.item_count>0)e.style.display=''})})}

  /* Gallery anim */
function initGalleryAnim(){var g=S.querySelector('[data-gallery-anim]');if(g)requestAnimationFrame(function(){g.classList.add('is-loaded')})}
/* Fade in */
  function initAnim(){
    var items=S.querySelectorAll('.cds-pp__info > *');if(!items.length)return;
    var obs=new IntersectionObserver(function(e){e.forEach(function(en){if(en.isIntersecting){en.target.classList.add('is-visible');obs.unobserve(en.target)}})},{threshold:0.08});
    items.forEach(function(el,i){el.style.transitionDelay=(i*0.06)+'s';obs.observe(el)});
  }

  /* ═══ BUNDLE PICKER ═══ */
  var COLOR_MAP_BP={'noir':'#000','black':'#000','blanc':'#fff','white':'#fff','rouge':'#c0392b','red':'#c0392b','bleu':'#2980b9','blue':'#2980b9','vert':'#27ae60','green':'#27ae60','jaune':'#f1c40f','yellow':'#f1c40f','rose':'#e91e8b','pink':'#e91e8b','orange':'#e67e22','violet':'#8e44ad','purple':'#8e44ad','gris':'#95a5a6','grey':'#95a5a6','gray':'#95a5a6','marron':'#6d4c41','brown':'#6d4c41','beige':'#d4c5a9','creme':'#f5f0e1','cream':'#f5f0e1','bordeaux':'#722f37','burgundy':'#722f37','navy':'#1a237e','marine':'#1a237e','turquoise':'#1abc9c','corail':'#e74c3c','coral':'#e74c3c','or':'#d4a843','gold':'#d4a843','argent':'#c0c0c0','silver':'#c0c0c0','kaki':'#6b6b3d','khaki':'#6b6b3d','camel':'#c19a6b','ivoire':'#fffff0','ivory':'#fffff0','taupe':'#483c32','sable':'#c2b280','sand':'#c2b280'};
  var BP_COLOR_NAMES=['color','colour','couleur','farbe','colore','color/colour'];
  function bpIsColor(n){return BP_COLOR_NAMES.indexOf(n.toLowerCase().trim())>=0}
  function bpColorHex(n){return COLOR_MAP_BP[n.toLowerCase().trim()]||null}
  function bpSizedImg(src,sz){if(!src)return'';return src.replace(/_(pico|icon|thumb|small|compact|medium|large|grande|original|1024x1024|2048x2048|master)(\.|_)/,'.$2').replace(/\.([^.]+)$/,'_'+sz+'.$1')}

  /* Global store: one entry per bundle_picker block */
  S._bundlePickers = [];

  function initBundlePicker(){
    var bpBlocks = S.querySelectorAll('[data-bp]');
    if(!bpBlocks.length) return;

    /* Shared modal elements */
    var sec = S.closest('section') || S;
    var mBackdrop = sec.parentElement.querySelector('[data-bp-modal-backdrop]') || document.querySelector('[data-bp-modal-backdrop]');
    var modal = sec.parentElement.querySelector('[data-bp-modal]') || document.querySelector('[data-bp-modal]');
    var mClose = modal.querySelector('[data-bp-modal-close]');
    var mSearch = modal.querySelector('[data-bp-modal-search]');
    var mGrid = modal.querySelector('[data-bp-modal-grid]');
    var mCount = modal.querySelector('[data-bp-modal-count]');
    var mConfirm = modal.querySelector('[data-bp-modal-confirm]');
    var mTitle = modal.querySelector('[data-bp-modal-title]');

    /* Shared variant sub-modal elements */
    var vBackdrop = sec.parentElement.querySelector('[data-bp-var-backdrop]') || document.querySelector('[data-bp-var-backdrop]');
    var vModal = sec.parentElement.querySelector('[data-bp-var-modal]') || document.querySelector('[data-bp-var-modal]');
    var vClose = vModal.querySelector('[data-bp-var-close]');
    var vImg = vModal.querySelector('[data-bp-var-img]');
    var vTitle = vModal.querySelector('[data-bp-var-title]');
    var vPrice = vModal.querySelector('[data-bp-var-price]');
    var vOptions = vModal.querySelector('[data-bp-var-options]');
    var vAdd = vModal.querySelector('[data-bp-var-add]');
    var vSoldoutMsg = vModal.querySelector('[data-bp-var-soldout-msg]');

    var activePicker = null; /* current block being edited */
    var allProducts = []; /* cached products for current modal */
    var tempSelections = []; /* temp selections inside modal */
    var variantProduct = null; /* product being configured in variant sub-modal */
    var variantSelOpts = {}; /* selected options in variant sub-modal */
    var bpPage = 0; /* current page */
    var bpPerPage = 12; /* products per page */
    var mPagination = modal.querySelector('[data-bp-modal-pagination]');
    var mPagePrev = modal.querySelector('[data-bp-page-prev]');
    var mPageNext = modal.querySelector('[data-bp-page-next]');
    var mPageInfo = modal.querySelector('[data-bp-page-info]');
    var mTabs = modal.querySelector('[data-bp-modal-tabs]');
    var tabBtns = mTabs.querySelectorAll('[data-bp-tab]');

    /* Init each block */
    bpBlocks.forEach(function(bpEl){
      var handle = bpEl.dataset.bpCollection;
      var maxP = parseInt(bpEl.dataset.bpMax) || 3;
      var blockId = bpEl.dataset.bpBlockId;

      /* Multi-collection support */
      var collections = [{handle: handle, label: bpEl.dataset.bpCollectionLabel || 'Collection 1', cache: null}];
      var h2 = bpEl.dataset.bpCollection2;
      var h3 = bpEl.dataset.bpCollection3;
      if(h2) collections.push({handle: h2, label: bpEl.dataset.bpCollection2Label || 'Collection 2', cache: null});
      if(h3) collections.push({handle: h3, label: bpEl.dataset.bpCollection3Label || 'Collection 3', cache: null});

      var picker = {
        el: bpEl,
        handle: handle,
        collections: collections,
        activeTab: 0,
        max: maxP,
        originalMax: maxP,
        dynamicMax: bpEl.dataset.bpDynamicMax === 'true',
        dynamicSource: parseInt(bpEl.dataset.bpDynamicSource) || 0,
        blockId: blockId,
        required: bpEl.dataset.bpRequired === 'true',
        noteLabel: bpEl.dataset.bpNoteLabel || '',
        noteValue: bpEl.dataset.bpNoteValue || '',
        reorder: bpEl.dataset.bpReorder === 'true',
        trustOrder: bpEl.dataset.bpTrustOrder === 'true',
        trustLabel: bpEl.dataset.bpTrustLabel || "Je vous fais confiance pour l'ordre",
        trustChecked: false,
        slotLabel: bpEl.dataset.bpSlotLabel || 'Produit',
        items: [], /* { variantId, productId, title, price, image, quantity, handle } */
        cache: null
      };
      S._bundlePickers.push(picker);

      /* Click slot cards to open modal */
      bpEl.querySelectorAll('[data-bp-slot-card]').forEach(function(card){
        card.addEventListener('click', function(e){
          if(e.target.closest('[data-bp-slot-remove]')) return;
          if(card.classList.contains('has-product')) return;
          openModal(picker);
        });
      });

      /* Collapsible toggle */
      var bpToggle = bpEl.querySelector('[data-bp-toggle]');
      var bpBody = bpEl.querySelector('[data-bp-body]');
      if(bpToggle && bpBody){
        bpToggle.addEventListener('click', function(){
          var wasCollapsed = bpBody.classList.contains('is-collapsed');
          if(wasCollapsed){
            /* Expanding — animate from 0 to real content height */
            bpBody.classList.remove('is-collapsed');
            bpBody.style.maxHeight = bpBody.scrollHeight + 'px';
            bpToggle.setAttribute('aria-expanded', 'true');
            setTimeout(function(){ bpBody.style.maxHeight = ''; }, 400);
          } else {
            /* Collapsing — set precise height first, then animate to 0 */
            bpBody.style.maxHeight = bpBody.scrollHeight + 'px';
            bpBody.offsetHeight; /* force reflow */
            bpBody.style.maxHeight = '0';
            bpBody.classList.add('is-collapsed');
            bpToggle.setAttribute('aria-expanded', 'false');
            setTimeout(function(){ bpBody.style.maxHeight = ''; }, 400);
          }
        });
        /* Set initial max-height for smooth first open if collapsed by default */
        if(bpBody.classList.contains('is-collapsed')){
          bpBody.style.maxHeight = '0';
        }
      }

      /* Trust order checkbox binding */
      if(picker.reorder && picker.trustOrder){
        var trustEl = bpEl.querySelector('[data-bp-trust]');
        var trustCheck = bpEl.querySelector('[data-bp-trust-check]');
        if(trustEl && trustCheck){
          trustCheck.addEventListener('change', function(){
            picker.trustChecked = trustCheck.checked;
            renderSlots(picker);
          });
        }
      }

      /* Initial render to show 0/X counter */
      renderSlots(picker);
    });

    /* Update slots UI for a picker */
    function renderSlots(picker){
      var slots = picker.el.querySelectorAll('[data-bp-slot]');
      var slotsContainer = picker.el.querySelector('.cds-pp__bp-slots');
      /* Reorder is active only when enabled AND trust is NOT checked */
      var reorderActive = picker.reorder && !picker.trustChecked;
      /* Toggle reorder class on container */
      if(slotsContainer){
        if(reorderActive) slotsContainer.classList.add('bp-reorder-enabled');
        else slotsContainer.classList.remove('bp-reorder-enabled');
      }

      slots.forEach(function(slot, i){
        var card = slot.querySelector('[data-bp-slot-card]');
        var label = slot.querySelector('.cds-pp__bp-slot-label');
        var item = picker.items[i] || null;

        /* Remove old price/qty/order elements */
        var oldPrice = slot.querySelector('.cds-pp__bp-slot-price');
        if(oldPrice) oldPrice.remove();
        var oldQty = slot.querySelector('.cds-pp__bp-slot-qty');
        if(oldQty) oldQty.remove();

        /* Clean drag state */
        slot.classList.remove('bp-dragging', 'bp-drag-over');
        slot.removeAttribute('draggable');

        if(item){
          card.classList.add('has-product');
          var orderBadge = reorderActive ? '<span class="cds-pp__bp-slot-order">'+(i+1)+'</span>' : '';
          /* Arrow buttons ON the image for reorder (mobile-friendly, no long press) */
          var arrowsHtml = '';
          if(reorderActive && picker.items.length > 1){
            var lDis = i === 0 ? ' disabled' : '';
            var rDis = i === picker.items.length - 1 ? ' disabled' : '';
            arrowsHtml = '<div class="cds-pp__bp-slot-arrows">'
              + '<button type="button" class="cds-pp__bp-slot-arrow" data-bp-arrow="left" data-bp-arrow-idx="'+i+'"'+lDis+'><svg viewBox="0 0 24 24" fill="none" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"/></svg></button>'
              + '<button type="button" class="cds-pp__bp-slot-arrow" data-bp-arrow="right" data-bp-arrow-idx="'+i+'"'+rDis+'><svg viewBox="0 0 24 24" fill="none" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 6 15 12 9 18"/></svg></button>'
              + '</div>';
          }
          card.innerHTML = orderBadge+'<img class="cds-pp__bp-slot-img" src="'+escapeHtml(item.image)+'" alt="'+escapeHtml(item.title)+'">' + arrowsHtml + '<button type="button" class="cds-pp__bp-slot-remove" data-bp-slot-remove data-bp-slot-idx="'+i+'"><svg viewBox="0 0 24 24" fill="none" stroke-linecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg></button>';
          label.textContent = item.title;
          label.classList.add('has-product');
          /* Price */
          var priceEl = document.createElement('div');
          priceEl.className = 'cds-pp__bp-slot-price';
          priceEl.textContent = fmt(item.price * item.quantity);
          slot.appendChild(priceEl);
          /* Qty */
          if(item.quantity > 1){
            var qtyEl = document.createElement('div');
            qtyEl.className = 'cds-pp__bp-slot-qty';
            qtyEl.textContent = 'x' + item.quantity;
            slot.appendChild(qtyEl);
          }
          /* Make draggable if reorder active (desktop only) */
          if(reorderActive) slot.setAttribute('draggable', 'true');
          /* Bind remove */
          card.querySelector('[data-bp-slot-remove]').addEventListener('click', function(e){
            e.stopPropagation();
            picker.items.splice(i, 1);
            applyDynamicMax(picker);
            renderSlots(picker);
          });
          /* Bind arrow reorder buttons */
          if(reorderActive){
            card.querySelectorAll('[data-bp-arrow]').forEach(function(arrow){
              arrow.addEventListener('click', function(ae){
                ae.stopPropagation();
                ae.preventDefault();
                var dir = arrow.dataset.bpArrow;
                var idx = parseInt(arrow.dataset.bpArrowIdx);
                if(dir === 'left') swapItems(picker, idx, idx - 1);
                else swapItems(picker, idx, idx + 1);
              });
            });
          }
        } else {
          card.classList.remove('has-product');
          card.innerHTML = '<div class="cds-pp__bp-slot-plus"><svg viewBox="0 0 24 24" fill="none" stroke-linecap="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg></div>';
          label.textContent = picker.slotLabel + ' ' + (i + 1);
          label.classList.remove('has-product');
        }
      });

      /* Show / hide trust checkbox when items exist */
      var trustEl = picker.el.querySelector('[data-bp-trust]');
      if(trustEl){
        trustEl.style.display = picker.items.length > 0 ? '' : 'none';
      }

      /* Hide "Glissez pour réordonner" hint when trust is checked */
      var reorderHints = picker.el.querySelectorAll('.cds-pp__bp-reorder-hint');
      reorderHints.forEach(function(hint){
        hint.style.display = reorderActive ? '' : 'none';
      });

      /* Counter — always visible */
      var counter = picker.el.querySelector('[data-bp-counter]');
      var cText = picker.el.querySelector('[data-bp-counter-text]');
      var cFill = picker.el.querySelector('[data-bp-counter-fill]');
      var hCounter = picker.el.querySelector('[data-bp-header-counter]');
      var hcText = picker.el.querySelector('[data-bp-header-counter-text]');
      var hcFill = picker.el.querySelector('[data-bp-header-counter-fill]');
      counter.style.display = '';
      cText.textContent = picker.items.length + '/' + picker.max;
      cFill.style.width = (picker.items.length / picker.max * 100) + '%';
      if(hCounter){ hCounter.style.display = ''; hcText.textContent = picker.items.length + '/' + picker.max; hcFill.style.width = (picker.items.length / picker.max * 100) + '%'; }

      /* Subtotal */
      var subEl = picker.el.querySelector('[data-bp-subtotal]');
      if(picker.items.length > 0){
        var sub = 0;
        picker.items.forEach(function(it){ sub += it.price * it.quantity; });
        subEl.textContent = 'Sous-total : ' + fmt(sub);
        subEl.classList.add('is-visible');
      } else {
        subEl.classList.remove('is-visible');
      }

      /* Bind drag & drop if reorder active (enabled AND trust not checked) */
      if(picker.reorder && !picker.trustChecked) bindDragDrop(picker);
    }

    /* ═══ DRAG & DROP REORDER ═══ */
    var bpDrag = { active: false, fromIdx: -1, picker: null };

    function getSlotIdx(slotEl){
      var slots = Array.prototype.slice.call(slotEl.parentElement.children);
      return slots.indexOf(slotEl);
    }

    function swapItems(picker, fromIdx, toIdx){
      if(fromIdx === toIdx) return;
      if(fromIdx < 0 || fromIdx >= picker.items.length) return;
      if(toIdx < 0 || toIdx >= picker.items.length) return;
      var moved = picker.items.splice(fromIdx, 1)[0];
      picker.items.splice(toIdx, 0, moved);
      renderSlots(picker);
    }

    /* Clean up desktop drag state */
    function dragCleanup(){
      document.querySelectorAll('.bp-dragging,.bp-drag-over').forEach(function(el){ el.classList.remove('bp-dragging','bp-drag-over'); });
      bpDrag.active = false;
      bpDrag.fromIdx = -1;
      bpDrag.picker = null;
    }

    /* Desktop-only HTML5 Drag & Drop (mobile uses arrow buttons on the card) */
    function bindDragDrop(picker){
      var slots = picker.el.querySelectorAll('[data-bp-slot]');

      slots.forEach(function(slot, i){
        if(!picker.items[i]) return;

        slot.addEventListener('dragstart', function(e){
          if(!picker.items[i]) return;
          dragCleanup();
          bpDrag.fromIdx = i;
          bpDrag.picker = picker;
          bpDrag.active = true;
          slot.classList.add('bp-dragging');
          e.dataTransfer.effectAllowed = 'move';
          e.dataTransfer.setData('text/plain', String(i));
        });

        slot.addEventListener('dragover', function(e){
          e.preventDefault();
          e.dataTransfer.dropEffect = 'move';
          if(!bpDrag.active || bpDrag.picker !== picker) return;
          var idx = getSlotIdx(slot);
          if(idx < picker.items.length && idx !== bpDrag.fromIdx){
            slot.classList.add('bp-drag-over');
          }
        });

        slot.addEventListener('dragleave', function(){
          slot.classList.remove('bp-drag-over');
        });

        slot.addEventListener('drop', function(e){
          e.preventDefault();
          if(!bpDrag.active || bpDrag.picker !== picker) return;
          var toIdx = getSlotIdx(slot);
          var from = bpDrag.fromIdx;
          dragCleanup();
          swapItems(picker, from, toIdx);
        });

        slot.addEventListener('dragend', function(){
          dragCleanup();
        });
      });
    }

    /* Open modal for a picker */
    function openModal(picker){
      activePicker = picker;
      tempSelections = picker.items.map(function(it){ return Object.assign({}, it); });
      mSearch.value = '';
      bpPage = 0;
      if(picker.el.dataset.bpCollection){
        var blockSettings = picker.el.querySelectorAll('.cds-pp__bp-title');
        var title = blockSettings.length ? blockSettings[0].textContent : 'Choisissez vos produits';
        mTitle.textContent = title || 'Choisissez vos produits';
      }
      /* Propagate accent color + text color to modal + variant sub-modal */
      var accentColor = getComputedStyle(picker.el).getPropertyValue('--bp-accent').trim() || '#1a1a1a';
      var accentText = getComputedStyle(picker.el).getPropertyValue('--bp-accent-text').trim() || '#fff';
      modal.style.setProperty('--bp-accent', accentColor);
      modal.style.setProperty('--bp-accent-text', accentText);
      vModal.style.setProperty('--bp-accent', accentColor);
      vModal.style.setProperty('--bp-accent-text', accentText);
      /* Tab bar setup */
      if(picker.collections.length > 1) {
        mTabs.style.display = '';
        tabBtns.forEach(function(t, i) {
          if(i < picker.collections.length) {
            t.style.display = '';
            t.textContent = picker.collections[i].label;
            t.classList.toggle('is-active', i === 0);
            t.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
          } else {
            t.style.display = 'none';
          }
        });
      } else {
        mTabs.style.display = 'none';
      }
      picker.activeTab = 0;

      mBackdrop.classList.add('is-open');
      modal.classList.add('is-open');
      document.body.style.overflow = 'hidden';

      loadProducts(picker);
      updateModalFooter();
    }

    function closeModal(){
      mBackdrop.classList.remove('is-open');
      modal.classList.remove('is-open');
      document.body.style.overflow = '';
      activePicker = null;
    }

    function loadProducts(picker){
      var col = picker.collections[picker.activeTab];
      if(col.cache) {
        allProducts = col.cache;
        renderGrid(allProducts);
        return;
      }
      var skeletonHtml='';for(var sk=0;sk<6;sk++) skeletonHtml+='<div class="cds-bp-modal__skeleton"></div>';
      mGrid.innerHTML = skeletonHtml;
      mPagination.style.display = 'none';
      fetch('/collections/'+col.handle+'/products.json?limit=250')
        .then(function(r){return r.json()})
        .then(function(data){
          allProducts = data.products || [];
          col.cache = allProducts;
          renderGrid(allProducts);
        })
        .catch(function(){
          mGrid.innerHTML = '<div class="cds-bp-modal__empty">Impossible de charger les produits</div>';
        });
    }

    /* Load ALL collections then call callback with merged products (deduped) */
    function loadAllProducts(picker, callback){
      var cols = picker.collections;
      var pending = 0;
      cols.forEach(function(col){
        if(!col.cache) pending++;
      });
      if(pending === 0){
        callback(mergeAllCached(cols));
        return;
      }
      var skeletonHtml='';for(var sk=0;sk<6;sk++) skeletonHtml+='<div class="cds-bp-modal__skeleton"></div>';
      mGrid.innerHTML = skeletonHtml;
      mPagination.style.display = 'none';
      cols.forEach(function(col){
        if(col.cache){ checkDone(); return; }
        fetch('/collections/'+col.handle+'/products.json?limit=250')
          .then(function(r){return r.json()})
          .then(function(data){ col.cache = data.products || []; })
          .catch(function(){ col.cache = []; })
          .then(checkDone);
      });
      function checkDone(){
        pending--;
        if(pending <= 0) callback(mergeAllCached(cols));
      }
    }
    function mergeAllCached(cols){
      var seen = {};
      var merged = [];
      cols.forEach(function(col){
        (col.cache || []).forEach(function(p){
          if(!seen[p.id]){ seen[p.id] = true; merged.push(p); }
        });
      });
      return merged;
    }

    function renderGrid(products){
      var q = mSearch.value.toLowerCase().trim();
      var filtered = products;
      if(q) filtered = products.filter(function(p){return p.title.toLowerCase().indexOf(q) >= 0});
      if(!filtered.length){
        mGrid.innerHTML = '<div class="cds-bp-modal__empty">Aucun produit trouvé</div>';
        mPagination.style.display = 'none';
        return;
      }
      /* Pagination */
      var totalPages = Math.ceil(filtered.length / bpPerPage);
      if(bpPage >= totalPages) bpPage = totalPages - 1;
      if(bpPage < 0) bpPage = 0;
      var start = bpPage * bpPerPage;
      var pageProducts = filtered.slice(start, start + bpPerPage);
      /* Show/hide pagination */
      if(totalPages > 1){
        mPagination.style.display = '';
        mPageInfo.textContent = (bpPage + 1) + ' / ' + totalPages;
        mPagePrev.disabled = bpPage <= 0;
        mPageNext.disabled = bpPage >= totalPages - 1;
      } else {
        mPagination.style.display = 'none';
      }
      var html = '';
      pageProducts.forEach(function(p){
        var firstV = p.variants[0];
        var available = p.variants.some(function(v){return v.available || !v.inventory_management || v.inventory_policy === 'continue'});
        var hasVariants = p.variants.length > 1;
        var img = p.images && p.images.length ? p.images[0].src.replace(/\.([^.]+)$/, '_400x.$1') : '';
        var selectedCount = tempSelections.filter(function(it){return String(it.productId) === String(p.id)}).length;
        var isSelected = selectedCount > 0;
        var comparePrice = firstV.compare_at_price && firstV.compare_at_price > firstV.price ? firstV.compare_at_price : 0;
        var savePct = comparePrice ? Math.round((comparePrice - firstV.price) / comparePrice * 100) : 0;

        html += '<div class="cds-bp-modal__card'+(isSelected?' is-selected':'')+(available?'':' is-soldout')+'" data-bp-card data-bp-pid="'+p.id+'" data-bp-json=\''+JSON.stringify(p).replace(/'/g,"&#39;")+'\' data-bp-has-variants="'+(hasVariants?'1':'0')+'">';
        if(selectedCount > 1) html += '<span class="cds-bp-modal__card-count">&times;'+selectedCount+'</span>';
        if(savePct) html += '<span class="cds-bp-modal__card-badge">-'+savePct+'%</span>';
        if(!available) html += '<span class="cds-bp-modal__card-badge cds-bp-modal__card-badge--soldout">Épuisé</span>';
        html += '<div class="cds-bp-modal__card-check"><svg viewBox="0 0 24 24" fill="none" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg></div>';
        var noImgSrc = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 400 400'%3E%3Crect width='400' height='400' fill='%23f0f0f0'/%3E%3Csvg x='140' y='140' width='120' height='120' viewBox='0 0 24 24' fill='none' stroke='%23ccc' stroke-width='1.5'%3E%3Crect x='3' y='3' width='18' height='18' rx='2'/%3E%3Ccircle cx='8.5' cy='8.5' r='1.5'/%3E%3Cpath d='m21 15-5-5L5 21'/%3E%3C/svg%3E%3C/svg%3E";
        var imgSrc = img || noImgSrc;
        var fullImgSrc = p.images && p.images.length ? p.images[0].src : '';
        html += '<div class="cds-bp-modal__card-img-wrap">';
        html += '<img class="cds-bp-modal__card-img" src="'+escapeHtml(imgSrc)+'" alt="'+escapeHtml(p.title)+'" loading="lazy" onerror="this.onerror=null;this.src=\''+noImgSrc+'\';">';
        if(fullImgSrc) html += '<button class="cds-bp-modal__card-zoom" data-bp-zoom="'+escapeHtml(fullImgSrc)+'" type="button" aria-label="Agrandir l\'image"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg></button>';
        html += '</div>';
        html += '<div class="cds-bp-modal__card-body">';
        html += '<h4 class="cds-bp-modal__card-title">'+escapeHtml(p.title)+'</h4>';
        html += '<div>';
        if(comparePrice) html += '<span class="cds-bp-modal__card-price--compare">'+fmt(comparePrice * 100)+'</span>';
        html += '<span class="cds-bp-modal__card-price">'+fmt(firstV.price * 100)+'</span>';
        html += '</div>';
        if(hasVariants) html += '<div class="cds-bp-modal__card-variants">'+p.variants.length+' variantes</div>';
        html += '</div></div>';
      });
      mGrid.innerHTML = html;
      bindCardClicks();
    }

    function bindCardClicks(){
      mGrid.querySelectorAll('[data-bp-card]').forEach(function(card){
        card.addEventListener('click', function(){
          var pid = card.dataset.bpPid;
          var pData = JSON.parse(card.dataset.bpJson);

          /* If max already reached → do nothing (deselect via slot × buttons) */
          if(tempSelections.length >= activePicker.max) return;

          /* Always open variant modal (allows same product with different variants) */
          openVariantModal(pData, card);
        });
      });
      /* Zoom eye-icon handlers */
      mGrid.querySelectorAll('[data-bp-zoom]').forEach(function(btn){
        btn.addEventListener('click', function(e){
          e.stopPropagation();
          e.preventDefault();
          var src = btn.dataset.bpZoom;
          var zOverlay = document.querySelector('[data-bp-zoom-overlay]');
          var zImg = zOverlay.querySelector('[data-bp-zoom-img]');
          zImg.src = src;
          zImg.alt = btn.closest('[data-bp-card]') ? btn.closest('[data-bp-card]').querySelector('.cds-bp-modal__card-title').textContent : '';
          requestAnimationFrame(function(){ zOverlay.classList.add('is-active'); });
        });
      });
    }

    function updateModalFooter(){
      var count = tempSelections.length;
      var max = activePicker ? activePicker.max : 0;
      mCount.textContent = count + '/' + max + ' sélectionné' + (count > 1 ? 's' : '');
    }

    /* Variant sub-modal */
    function openVariantModal(pData, card){
      variantProduct = pData;
      variantSelOpts = {};
      vTitle.textContent = pData.title;
      var img = pData.images && pData.images.length ? pData.images[0].src.replace(/\.([^.]+)$/, '_500x.$1') : '';
      vImg.src = img;

      /* Populate product description */
      var descEl = vModal.querySelector('[data-bp-var-desc]');
      if(descEl) descEl.innerHTML = (pData.body_html || '').replace(/<img[^>]*>/gi, '');

      /* Helper: check if any available variant exists with val at optionIndex */
      function bpHasAvailableForOpt(variants, optIdx, val, otherSel){
        for(var i=0;i<variants.length;i++){
          var v=variants[i];
          if(!v.available && v.inventory_management && v.inventory_policy !== 'continue') continue;
          if(v['option'+(optIdx+1)]!==val) continue;
          var ok=true;
          for(var k in otherSel){
            if(parseInt(k)===optIdx) continue;
            if(v['option'+(parseInt(k)+1)]!==otherSel[k]){ok=false;break}
          }
          if(ok) return true;
        }
        return false;
      }

      /* Update sold-out indicators on all option buttons */
      function updateVarSoldoutStates(){
        vOptions.querySelectorAll('[data-bp-opt-idx]').forEach(function(b){
          var oi=parseInt(b.dataset.bpOptIdx);
          var ov=b.dataset.bpOptVal;
          var avail=bpHasAvailableForOpt(pData.variants, oi, ov, variantSelOpts);
          b.classList.toggle('is-soldout',!avail);
        });
      }

      /* Build options */
      var optsHtml = '';
      (pData.options || []).forEach(function(opt, idx){
        var isColor = bpIsColor(opt.name || opt);
        var optName = opt.name || opt;
        var optVals = [];
        pData.variants.forEach(function(v){
          var val = v['option'+(idx+1)];
          if(val && optVals.indexOf(val) === -1) optVals.push(val);
        });
        optsHtml += '<div class="cds-bp-variant__group"><div class="cds-bp-variant__label">'+escapeHtml(optName)+' : <span data-bp-label-idx="'+idx+'"></span></div><div class="cds-bp-variant__options">';
        optVals.forEach(function(val){
          var isAvail = bpHasAvailableForOpt(pData.variants, idx, val, {});
          var soldoutCls = isAvail ? '' : ' is-soldout';
          if(isColor){
            var hex = bpColorHex(val);
            var cImg = '';
            for(var vi=0;vi<pData.variants.length;vi++){
              var vr=pData.variants[vi];
              if(vr['option'+(idx+1)]===val && vr.featured_image){
                cImg=bpSizedImg(vr.featured_image.src,'80x');break;
              }
            }
            optsHtml += '<button type="button" class="cds-bp-variant__swatch-color'+soldoutCls+'" data-bp-opt-idx="'+idx+'" data-bp-opt-val="'+escapeHtml(val)+'" title="'+escapeHtml(val)+(isAvail?'':' (Épuisé)')+'">';
            if(cImg) optsHtml += '<img src="'+cImg+'" alt="'+escapeHtml(val)+'">';
            else if(hex) optsHtml += '<span style="background:'+hex+'"></span>';
            else optsHtml += '<span style="background:linear-gradient(135deg,#ddd,#999)"></span>';
            optsHtml += '</button>';
          } else {
            optsHtml += '<button type="button" class="cds-bp-variant__swatch-pill'+soldoutCls+'" data-bp-opt-idx="'+idx+'" data-bp-opt-val="'+escapeHtml(val)+'">'+escapeHtml(val)+(isAvail?'':' (Épuisé)')+'</button>';
          }
        });
        optsHtml += '</div></div>';
      });
      vOptions.innerHTML = optsHtml;

      /* Price — use first available variant or first variant */
      var fv = pData.variants.find(function(v){return v.available || !v.inventory_management || v.inventory_policy === 'continue'}) || pData.variants[0];
      updateVarPrice(fv.price * 100, fv.compare_at_price ? fv.compare_at_price * 100 : 0);

      vAdd.disabled = true;
      vSoldoutMsg.classList.remove('is-visible');
      vAdd.textContent = 'Ajouter au bundle';

      /* Single-variant product: hide options, enable add immediately */
      var singleVar = pData.variants.length === 1;
      if(singleVar) {
        vOptions.innerHTML = '';
        var sv = pData.variants[0];
        var svAvail = sv.available || !sv.inventory_management || sv.inventory_policy === 'continue';
        vAdd.disabled = !svAvail;
        if(!svAvail){ vSoldoutMsg.classList.add('is-visible'); vAdd.textContent = 'Épuisé'; }
        /* Pre-fill selections so findVarExact works */
        (pData.options || []).forEach(function(opt, idx){ variantSelOpts[idx] = sv['option'+(idx+1)]; });
      }

      /* Bind option clicks */
      vOptions.querySelectorAll('[data-bp-opt-idx]').forEach(function(btn){
        btn.addEventListener('click', function(){
          var idx = parseInt(btn.dataset.bpOptIdx);
          var val = btn.dataset.bpOptVal;
          variantSelOpts[idx] = val;
          /* Update label with selected value */
          var labelSpan = btn.closest('.cds-bp-variant__group').querySelector('[data-bp-label-idx="'+idx+'"]');
          if(labelSpan) labelSpan.textContent = val;
          /* Active state */
          btn.closest('.cds-bp-variant__options').querySelectorAll('[data-bp-opt-idx]').forEach(function(b){b.classList.remove('is-active')});
          btn.classList.add('is-active');
          /* Update sold-out states on other option groups */
          updateVarSoldoutStates();
          /* Update image + price */
          var match = findVarPartial(pData, variantSelOpts);
          if(match && match.featured_image) vImg.src = bpSizedImg(match.featured_image.src, '500x');
          var exact = findVarExact(pData, variantSelOpts);
          if(exact) updateVarPrice(exact.price * 100, exact.compare_at_price ? exact.compare_at_price * 100 : 0);
          /* Enable add if all options selected AND variant is available */
          var allSel = Object.keys(variantSelOpts).length >= (pData.options || []).length;
          var exactVar = allSel ? findVarExact(pData, variantSelOpts) : null;
          var isAvailable = exactVar && (exactVar.available || !exactVar.inventory_management || exactVar.inventory_policy === 'continue');
          vAdd.disabled = !isAvailable;
          /* Show/hide sold-out message */
          if(allSel && exactVar && !isAvailable){
            vSoldoutMsg.classList.add('is-visible');
            vAdd.textContent = 'Épuisé';
          } else {
            vSoldoutMsg.classList.remove('is-visible');
            vAdd.textContent = 'Ajouter au bundle';
          }
        });
      });

      /* Already-selected variants of this product */
      var existSelWrap = vModal.querySelector('[data-bp-var-selected]');
      if(!existSelWrap){
        existSelWrap = document.createElement('div');
        existSelWrap.setAttribute('data-bp-var-selected', '');
        vAdd.parentElement.insertBefore(existSelWrap, vAdd);
      }
      var selectedOfProduct = tempSelections.filter(function(it){ return String(it.productId) === String(pData.id); });
      if(selectedOfProduct.length > 0){
        var selHtml = '<div class="cds-bp-variant__selected-list">';
        selHtml += '<div class="cds-bp-variant__selected-title">Déjà sélectionné</div>';
        selectedOfProduct.forEach(function(sel){
          var vName = sel.title.indexOf(' — ') >= 0 ? sel.title.split(' — ').slice(1).join(' — ') : sel.title;
          selHtml += '<div class="cds-bp-variant__selected-item">';
          selHtml += '<span>'+escapeHtml(vName)+'</span>';
          selHtml += '<button type="button" class="cds-bp-variant__selected-remove" data-bp-var-remove="'+sel.variantId+'">&times;</button>';
          selHtml += '</div>';
        });
        selHtml += '</div>';
        existSelWrap.innerHTML = selHtml;
        /* Bind remove buttons */
        existSelWrap.querySelectorAll('[data-bp-var-remove]').forEach(function(btn){
          btn.addEventListener('click', function(){
            var vid = btn.dataset.bpVarRemove;
            for(var i=0; i<tempSelections.length; i++){
              if(String(tempSelections[i].variantId) === String(vid)){
                tempSelections.splice(i, 1);
                break;
              }
            }
            updateModalFooter();
            closeVariantModal();
            renderGrid(allProducts);
          });
        });
      } else {
        existSelWrap.innerHTML = '';
      }

      /* Show sub-modal */
      vBackdrop.classList.add('is-open');
      vModal.classList.add('is-open');

      /* Eye-icon zoom in variant modal */
      var vZoomBtn = vModal.querySelector('[data-bp-var-zoom]');
      if(vZoomBtn){
        vZoomBtn.onclick = function(e){
          e.stopPropagation();
          var zOverlay = document.querySelector('[data-bp-zoom-overlay]');
          var zImg = zOverlay.querySelector('[data-bp-zoom-img]');
          zImg.src = vImg.src.replace(/_\d+x\./, '.');
          zImg.alt = pData.title;
          requestAnimationFrame(function(){ zOverlay.classList.add('is-active'); });
        };
      }

      /* Bind add button (one-time) */
      var addHandler = function(){
        var exact = findVarExact(pData, variantSelOpts);
        if(!exact || (!exact.available && exact.inventory_management && exact.inventory_policy !== 'continue')) return;
        var img2 = vImg.src || img;
        tempSelections.push({
          variantId: String(exact.id),
          productId: String(pData.id),
          title: pData.title + (exact.title !== 'Default Title' ? ' — ' + exact.title : ''),
          price: exact.price * 100,
          image: img2,
          quantity: 1,
          handle: pData.handle,
          tags: pData.tags || []
        });
        /* Mark card as selected in grid + refresh to update ×N badge */
        if(card) card.classList.add('is-selected');
        updateModalFooter();
        closeVariantModal();
        renderGrid(allProducts);
        vAdd.removeEventListener('click', addHandler);
      };
      vAdd.addEventListener('click', addHandler);
      vModal._addHandler = addHandler;
    }

    function closeVariantModal(){
      vBackdrop.classList.remove('is-open');
      vModal.classList.remove('is-open');
      if(vModal._addHandler) vAdd.removeEventListener('click', vModal._addHandler);
    }

    function updateVarPrice(price, compare){
      var html = '';
      if(compare && compare > price) html += '<span class="cds-bp-variant__price--compare">'+fmt(compare)+'</span> ';
      html += '<span class="cds-bp-variant__price">'+fmt(price)+'</span>';
      vPrice.innerHTML = html;
    }

    function findVarPartial(pData, sel){
      for(var i=0;i<pData.variants.length;i++){
        var v=pData.variants[i],ok=true;
        for(var idx in sel){if(v['option'+(parseInt(idx)+1)]!==sel[idx]){ok=false;break}}
        if(ok) return v;
      }
      return null;
    }

    function findVarExact(pData, sel){
      var n=(pData.options||[]).length;
      if(Object.keys(sel).length<n) return null;
      for(var i=0;i<pData.variants.length;i++){
        var v=pData.variants[i],ok=true;
        for(var idx=0;idx<n;idx++){if(v['option'+(idx+1)]!==sel[String(idx)]){ok=false;break}}
        if(ok) return v;
      }
      return null;
    }

    /* Search — cross-collection when query, active tab when empty */
    var searchTimer;
    mSearch.addEventListener('input', function(){
      clearTimeout(searchTimer);
      searchTimer = setTimeout(function(){
        bpPage = 0;
        var q = mSearch.value.trim();
        if(q && activePicker && activePicker.collections.length > 1){
          /* Hide tab active indicator during cross-search */
          tabBtns.forEach(function(b){ b.classList.remove('is-active'); b.setAttribute('aria-selected','false'); });
          loadAllProducts(activePicker, function(merged){
            allProducts = merged;
            renderGrid(allProducts);
          });
        } else {
          /* Empty search → restore active tab highlight + show its products */
          if(activePicker && activePicker.collections.length > 1){
            tabBtns.forEach(function(b,i){ b.classList.toggle('is-active', i === activePicker.activeTab); b.setAttribute('aria-selected', i === activePicker.activeTab ? 'true' : 'false'); });
          }
          if(activePicker){
            allProducts = activePicker.collections[activePicker.activeTab].cache || [];
          }
          renderGrid(allProducts);
        }
      }, 200);
    });

    /* Pagination */
    mPagePrev.addEventListener('click', function(){
      if(bpPage > 0){ bpPage--; renderGrid(allProducts); mGrid.parentElement.scrollTop = 0; }
    });
    mPageNext.addEventListener('click', function(){
      bpPage++; renderGrid(allProducts); mGrid.parentElement.scrollTop = 0;
    });

    /* Tab click handler */
    tabBtns.forEach(function(t) {
      t.addEventListener('click', function() {
        if(!activePicker) return;
        var idx = parseInt(this.dataset.bpTab);
        if(idx === activePicker.activeTab) return;
        activePicker.activeTab = idx;
        tabBtns.forEach(function(b, i) {
          b.classList.toggle('is-active', i === idx);
          b.setAttribute('aria-selected', i === idx ? 'true' : 'false');
        });
        bpPage = 0;
        mSearch.value = '';
        loadProducts(activePicker);
      });
    });

    /* Close modal */
    mClose.addEventListener('click', closeModal);
    mBackdrop.addEventListener('click', closeModal);
    vClose.addEventListener('click', closeVariantModal);
    vBackdrop.addEventListener('click', closeVariantModal);

    /* Zoom lightbox — close handlers */
    var zoomOverlay = document.querySelector('[data-bp-zoom-overlay]');
    var zoomCloseBtn = zoomOverlay ? zoomOverlay.querySelector('[data-bp-zoom-close]') : null;
    function closeZoom(){ if(zoomOverlay) zoomOverlay.classList.remove('is-active'); }
    if(zoomCloseBtn) zoomCloseBtn.addEventListener('click', closeZoom);
    if(zoomOverlay) zoomOverlay.addEventListener('click', function(e){ if(e.target === zoomOverlay) closeZoom(); });

    /* ═══ DYNAMIC MAX HELPERS ═══ */
    function extractBpLimit(tags){
      if(!tags || !tags.length) return null;
      var arr = typeof tags === 'string' ? tags.split(',') : tags;
      for(var i=0;i<arr.length;i++){
        var m = arr[i].trim().match(/^limit[:\-](\d+)$/i);
        if(m) return parseInt(m[1]);
      }
      return null;
    }

    function updateBpSlotCount(picker){
      var slotsContainer = picker.el.querySelector('.cds-pp__bp-slots');
      if(!slotsContainer) return;
      var currentSlots = slotsContainer.querySelectorAll('[data-bp-slot]');
      var currentCount = currentSlots.length;
      var targetCount = picker.max;
      if(targetCount === currentCount) return;
      if(targetCount < currentCount){
        /* Remove excess slots from the end */
        for(var r = currentCount - 1; r >= targetCount; r--){
          currentSlots[r].remove();
        }
      } else {
        /* Add missing slots */
        for(var a = currentCount; a < targetCount; a++){
          var slot = document.createElement('div');
          slot.className = 'cds-pp__bp-slot';
          slot.dataset.bpSlot = String(a);
          slot.innerHTML = '<div class="cds-pp__bp-slot-card" data-bp-slot-card="'+a+'"><div class="cds-pp__bp-slot-plus"><svg viewBox="0 0 24 24" fill="none" stroke-linecap="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg></div></div><div class="cds-pp__bp-slot-label">'+picker.slotLabel+' '+(a+1)+'</div>';
          slotsContainer.appendChild(slot);
          /* Bind click on new slot */
          slot.querySelector('[data-bp-slot-card]').addEventListener('click', function(e){
            if(e.target.closest('[data-bp-slot-remove]')) return;
            openModal(picker);
          });
        }
      }
    }

    function applyDynamicMax(sourcePicker){
      var sourceIdx = S._bundlePickers.indexOf(sourcePicker);
      S._bundlePickers.forEach(function(target){
        if(!target.dynamicMax || target.dynamicSource !== sourceIdx) return;
        var limit = null;
        if(sourcePicker.items.length > 0 && sourcePicker.items[0].tags){
          limit = extractBpLimit(sourcePicker.items[0].tags);
        }
        target.max = limit || target.originalMax;
        /* Remove excess items */
        while(target.items.length > target.max){
          target.items.pop();
        }
        updateBpSlotCount(target);
        renderSlots(target);
      });
    }

    /* Confirm */
    mConfirm.addEventListener('click', function(){
      if(!activePicker) return;
      activePicker.items = tempSelections.slice();
      applyDynamicMax(activePicker);
      renderSlots(activePicker);
      closeModal();
    });

    /* ESC key */
    document.addEventListener('keydown', function(e){
      if(e.key === 'Escape'){
        if(zoomOverlay && zoomOverlay.classList.contains('is-active')){closeZoom(); return}
        if(vModal.classList.contains('is-open')){closeVariantModal(); return}
        if(modal.classList.contains('is-open')){closeModal(); return}
      }
    });
  }

  /* Generate unique bundle group ID */
  S._generateBundleGroupId = function(){
    return 'cds-' + Date.now() + '-' + Math.random().toString(36).substr(2, 6);
  };

  /* Count existing bundles with same parent title to number them */
  S._getBundleNumber = function(parentTitle){
    var count = 0;
    try {
      var xhr = new XMLHttpRequest();
      xhr.open('GET', '/cart.js', false);
      xhr.send();
      if(xhr.status === 200){
        var cart = JSON.parse(xhr.responseText);
        (cart.items || []).forEach(function(ci){
          if(ci.properties && ci.properties['_bundle_role'] === 'parent' && ci.product_title === parentTitle) count++;
        });
      }
    } catch(e){}
    return count + 1;
  };

  /* Expose bundle items for form submission (with note as line item property) */
  S._getBundleItems = function(bundleGroupId, parentTitle){
    var items = [];
    (S._bundlePickers || []).forEach(function(picker){
      picker.items.forEach(function(it, idx){
        var item = { id: parseInt(it.variantId), quantity: it.quantity || 1 };
        item.properties = item.properties || {};
        if(bundleGroupId){
          item.properties['_bundle_group'] = bundleGroupId;
          item.properties['_bundle_role'] = 'child';
          if(parentTitle) item.properties['Bundle'] = parentTitle;
        }
        if(picker.noteLabel && picker.noteValue){
          item.properties[picker.noteLabel] = picker.noteValue;
        }
        /* Add order property when reorder is enabled */
        if(picker.reorder){
          if(picker.trustChecked){
            /* Trust mode: send trust label instead of order numbers */
            item.properties['Ordre'] = picker.trustLabel;
          } else {
            item.properties['Ordre'] = String(idx + 1);
          }
        }
        items.push(item);
      });
    });
    return items;
  };

  /* Validate required bundle pickers — returns error message or null */
  S._validateBundles = function(){
    var pickers = S._bundlePickers || [];
    for(var i = 0; i < pickers.length; i++){
      var pk = pickers[i];
      if(pk.required && pk.items.length < pk.max){
        var title = pk.el.querySelector('.cds-pp__bp-title');
        var label = title ? title.textContent.trim() : 'Bundle';

        /* Auto-expand collapsible if collapsed so error is visible */
        var bpToggle = pk.el.querySelector('[data-bp-toggle]');
        var bpBody = pk.el.querySelector('[data-bp-body]');
        if(bpToggle && bpBody && bpBody.classList.contains('is-collapsed')){
          bpBody.classList.remove('is-collapsed');
          bpBody.style.maxHeight = bpBody.scrollHeight + 'px';
          bpToggle.setAttribute('aria-expanded', 'true');
          setTimeout(function(){ bpBody.style.maxHeight = ''; }, 400);
        }

        var errEl = pk.el.querySelector('[data-bp-error]');
        if(errEl){
          errEl.textContent = 'Veuillez sélectionner ' + pk.max + ' produit' + (pk.max > 1 ? 's' : '') + ' pour « ' + label + ' »';
          errEl.classList.add('is-visible');
          setTimeout(function(){ errEl.classList.remove('is-visible'); }, 5000);
        }
        pk.el.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return 'Veuillez compléter « ' + label + ' » (' + pk.items.length + '/' + pk.max + ')';
      }
      /* Clear error if previously shown */
      var errEl2 = pk.el.querySelector('[data-bp-error]');
      if(errEl2) errEl2.classList.remove('is-visible');
    }
    return null;
  };

  /* INIT — each function is wrapped so a failure in one doesn't block the others */
  S.classList.add('cds-pp--anim-ready');
  var _fns=[initGallery,initCarousel,initVariants,initDesc,initTabs,initDel,initSizeGuide,initQty,initVolumeBundle,initCustomCheckboxes,initRecipientForm,initGiftWrapToggle,initPickup,initForm,initUpsell,initSDUpsell,initSticky,initSmartSticky,initAnim,initBundlePicker];
  _fns.forEach(function(fn){try{fn()}catch(e){console.error('CDS init error ['+fn.name+']:',e)}});
try{initZoom()}catch(e){console.error('CDS initZoom error:',e)}
try{initLightbox()}catch(e){console.error('CDS initLightbox error:',e)}
try{initCountdown()}catch(e){console.error('CDS initCountdown error:',e)}
try{initWishlist()}catch(e){console.error('CDS initWishlist error:',e)}
try{initShipBar()}catch(e){console.error('CDS initShipBar error:',e)}
try{initGalleryAnim()}catch(e){console.error('CDS initGalleryAnim error:',e)}
/* Theme Editor cleanup — prevent listener leaks on section reload */
  var sectionId=cfg.sectionId;
  document.addEventListener('shopify:section:unload',function(e){
    if(!e.detail||e.detail.sectionId!==sectionId)return;
    if(_smartStickyResizeHandler)window.removeEventListener('resize',_smartStickyResizeHandler);
    if(S._lbKeyHandler)document.removeEventListener('keydown',S._lbKeyHandler);
    if(S._sgKeyHandler)document.removeEventListener('keydown',S._sgKeyHandler);
    if(S._lbHide)S._lbHide();
    if(S._sgShut)S._sgShut();
    document.body.style.overflow='';
  });
  }
})();
